unit planning.enquiry;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics,
  VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomComponent, VCL.TMSFNCPlanner,
  VCL.TMSFNCPlannerDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCPlannerBase, VCL.TMSFNCPlannerData, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  System.DateUtils, VCL.TMSFNCPanel, WEBLib.Buttons, VCL.TMSFNCPageControl,
  VCL.TMSFNCTabSet, Vcl.Imaging.GIFImg, VCL.TMSFNCGridCell,
  VCL.TMSFNCGridOptions, VCL.TMSFNCCustomGrid, VCL.TMSFNCGridDatabaseAdapter,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid,
  WEBLib.DBCtrls, vehicle.details, Bcl.Utils,
  diesel.fuelorders.enquiry;

type
  TfrmPlanningEnquiry = class(TForm)
    wcPlanning: TXDataWebClient;
    qPlanning: TXDataWebDataSet;
    dsPlanning: TDataSource;
    qPlanningNo: TIntegerField;
    qPlanningRegSource: TIntegerField;
    qPlanningRegNo: TStringField;
    qPlanningContractNo: TIntegerField;
    qPlanningContractName: TStringField;
    qPlanningSubCode: TStringField;
    qPlanningSubName: TStringField;
    qPlanningCanceled: TBooleanField;
    qPlanningLoaded: TBooleanField;
    qPlanningOffLoaded: TBooleanField;
    qPlanningLoadconno: TIntegerField;
    qPlanningCInvoiceNo: TStringField;
    qPlanningCInvoiced: TBooleanField;
    qPlanningSInvoiceNo: TStringField;
    qPlanningSInvoiced: TBooleanField;
    qPlanningLoadStandTime: TTimeField;
    qPlanningOffLoadStandTime: TTimeField;
    qPlanningTrafelTime: TTimeField;
    qPlanningTimeLeft: TTimeField;
    qResources: TXDataWebDataSet;
    dsResources: TDataSource;
    wcResources: TXDataWebClient;
    qPlanningLoadingDate: TDateTimeField;
    qPlanningOffLoadingDate: TDateTimeField;
    qResourcesNo: TIntegerField;
    qResourcesRegNo: TStringField;
    qPlanningSystemType: TStringField;
    WebTimer1: TTimer;
    qDashBoard: TXDataWebDataSet;
    IntegerField1: TIntegerField;
    StringField1: TStringField;
    dsDashBoard: TDataSource;
    wcDashBoard: TXDataWebClient;
    qDashBoardSubCode: TStringField;
    qDashBoardSubName: TStringField;
    qDashBoardLoadsNotStarted: TIntegerField;
    qDashBoardLoadsStarted: TIntegerField;
    qDashBoardKilos: TIntegerField;
    qDashBoardLastKilosService: TIntegerField;
    qDashBoardKilosNextService: TIntegerField;
    qDashBoardDieselOrder: TIntegerField;
    qDashBoardWarnings: TIntegerField;
    gdaDashBoard: TTMSFNCGridDatabaseAdapter;
    qDashBoardLastLoadStart: TStringField;
    qDashBoardLastLoadPlan: TStringField;
    qDashBoardLastDieselOrder: TStringField;
    qDashBoardLoadEndTime: TDateTimeField;
    qDashBoardCurrentTime: TDateTimeField;
    qDashBoardTotalHours: TIntegerField;
    qDashBoardTimeLeft: TStringField;
    qDashBoardFirstwarning: TIntegerField;
    qDashBoardSecondwarning: TIntegerField;
    qDashBoardGroupNo: TIntegerField;
    qDashBoardGroupName: TStringField;
    qDashBoardRevenu: TFloatField;
    qDashBoardSurplus: TFloatField;
    qDashBoardDayAverage: TFloatField;
    qDashBoardDayGood: TFloatField;
    qDashBoardDayFirst: TFloatField;
    qDashBoardDaySecond: TFloatField;
    qDashBoardRevToDate: TFloatField;
    qDashBoardSurplusToDate: TFloatField;
    qDashBoardFuelConsumption: TFloatField;
    qDashBoardLoadCount: TIntegerField;
    qTotals: TXDataWebDataSet;
    dsTotals: TDataSource;
    wcTotals: TXDataWebClient;
    qTotalsCount: TIntegerField;
    qTotalsRevenue: TFloatField;
    qTotalsSurplus: TFloatField;
    qTotalsDayAverage: TFloatField;
    qTotalsFuel: TFloatField;
    qDashBoardSurplusPerc: TFloatField;
    WebLabel1: TLabel;
    TMSFNCPageControl1: TTMSFNCPageControl;
    TMSFNCPageControl1Page2: TTMSFNCPageControlContainer;
    TMSFNCPageControl1Page1: TTMSFNCPageControlContainer;
    TMSFNCPageControl1Page0: TTMSFNCPageControlContainer;
    pPlanner: TTMSFNCPlanner;
    pdaPlanner: TTMSFNCPlannerDatabaseAdapter;
    wpLoadsButtons: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    wpLoadsAdd: TPanel;
    WebWaitMessage1: TWaitMessage;
    TMSFNCPageControl1Page3: TTMSFNCPageControlContainer;
    gDashBoard: TTMSFNCGrid;
    sbBottom: TScrollBox;
    WebLabel6: TLabel;
    weCount: TEdit;
    weTotalRev: TEdit;
    weTotalSurplus: TEdit;
    weAvgDay: TEdit;
    weAvgFuel: TEdit;
    WebLabel11: TLabel;
    WebLabel10: TLabel;
    WebLabel9: TLabel;
    WebLabel8: TLabel;
    WebLabel7: TLabel;
    sbDashBoard: TScrollBox;
    WebLabel2: TLabel;
    lCompany: TEdit;
    WebSpeedButton3: TSpeedButton;
    WebLabel3: TLabel;
    lGroup: TEdit;
    WebSpeedButton4: TSpeedButton;
    WebLabel4: TLabel;
    lRegNo: TEdit;
    WebSpeedButton5: TSpeedButton;
    WebLabel12: TLabel;
    lController: TEdit;
    WebSpeedButton6: TSpeedButton;
    WebLabel5: TLabel;
    dtPicker: TDateTimePicker;
    btnSearch: TSpeedButton;
    WebMessageDlg1: TMessageDlg;
    procedure qResourcesAfterOpen(DataSet: TDataSet);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure qPlanningAfterOpen(DataSet: TDataSet);
    procedure pPlannerAfterNavigateToDateTime(Sender: TObject;
      ADirection: TTMSFNCPlannerNavigationDirection; ACurrentDateTime,
      ANewDateTime: TDateTime);
    procedure pPlannerAfterDrawItem(Sender: TObject; AGraphics: TTMSFNCGraphics;
      ARect: TRectF; AItem: TTMSFNCPlannerItem);
    procedure TMSFNCPageControl1ChangePage(Sender: TObject; APreviousPageIndex,
      ACurrentPageIndex: Integer);
    procedure WebFormShow(Sender: TObject);
    procedure qDashBoardAfterOpen(DataSet: TDataSet);
    procedure gDashBoardGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure WebTimer1Timer(Sender: TObject);
    procedure lCompanyKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure lGroupKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure lRegNoKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure gDashBoardSortFormat(Sender: TObject; Col: Integer;
      var SortFormat: TTMSFNCGridSortFormat; var APrefix, ASuffix: string);
    procedure btnSearchClick(Sender: TObject);
    procedure gDashBoardCellButtonClick(Sender: TObject; ACol, ARow: Integer;
      ACell: TTMSFNCGridCell);
    procedure qTotalsAfterOpen(DataSet: TDataSet);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure lControllerKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
  private
    { Private declarations }
    sCompany,
    sGroup,
    sRegNo,
    sController : String;
    iScrollBoxHeight,
    iScrollBoxWidth : Integer;
    LFrm : TfrmVehicleDetails;
    LFrm1 : TfrmFuelOrders;
    procedure DoGetDataShowScreen;
    procedure GetPlannerData;
    procedure DoGetDashBoardData;
  public
    { Public declarations }
    dtStart,
    dtEnd : TDate;
  protected procedure LoadDFMValues; override; end;

  TTMSFNCGridDataBaseAdapterOpen = class(TTMSFNCGridDatabaseAdapter);

var
  frmPlanningEnquiry: TfrmPlanningEnquiry;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common,
  stfmssystem.main,
  search.subs,
  search.vehgroups,
  search.controller,
  search.reg;

procedure TfrmPlanningEnquiry.btnSearchClick(Sender: TObject);
begin
  WebWaitMessage1.Show;
  DoGetDashBoardData;
end;

procedure TfrmPlanningEnquiry.DoGetDashBoardData;
  var
    wYear,
    wMonth,
    wDay : Word;
    dtlStart,
    dtlEnd : TDate;
  procedure OnError(Error: TXDataClientError);
  begin
    if WebWaitMessage1.Visible then
      WebWaitMessage1.Hide;
    WebMessageDlg1.ShowDialog(Error.ErrorMessage, WEBLib.Dialogs.mtError, [mbOk]);
  end;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    if WebWaitMessage1.Visible then
      WebWaitMessage1.Hide;
    qDashBoard.Close;
    qDashBoard.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    qDashBoard.Open;

  end;

  procedure OnResult2(Response : TXDataClientResponse);
  begin
    qTotals.Close;
    qTotals.SetJsonData(Response.Result);
    qTotals.Open;
    wcDashBoard.RawInvoke('IstfmsloadsService.GetPlanDashBoard', [sController,sCompany,sRegNo, TBclUtils.DateTimeToISO(dtlStart, true), TBclUtils.DateTimeToISO(dtlEnd,true), StrToInt(sGroup)], @OnResult, @OnError);
  end;
begin
  DecodeDate(dtPicker.Date,wYear,wMonth,wDay);
  dtlStart := EncodeDate(wYear,wMonth,1);
  dtlEnd := EncodeDate(wYear,wMonth,wDay);
  if sCompany = '' then
    sCompany := '*';
  if sGroup = '' then
    sGroup := '-1';
  if sRegNo = '' then
    sRegNo := '*';
  if sController = '' then
    sController := '*';
  wcTotals.RawInvoke('IstfmsloadsService.GetPlanDashBoardTotals', [sController,sCompany,sRegNo, StrToInt(sGroup), TBclUtils.DateTimeToISO(dtlStart,true), TBclUtils.DateTimeToISO(dtlEnd,true)], @OnResult2, @OnError);
end;

procedure TfrmPlanningEnquiry.DoGetDataShowScreen;
  var
    sValue : String;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    qResources.Close;
    qResources.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    qResources.Open;
  end;
begin
  WebWaitMessage1.Show;
  Case gDashBoard.Selection.StartCol of
    0 : begin
          sValue := gDashBoard.Cells[20,gDashBoard.Selection.StartRow];
          wcResources.RawInvoke('IstfmsloadsService.GetPlanResources', ['*',sValue,'*', dtStart, dtEnd, 1], @OnResult);
        end;
    1 : begin
          sValue := gDashBoard.Cells[21,gDashBoard.Selection.StartRow];
          wcResources.RawInvoke('IstfmsloadsService.GetPlanResources', [sValue,'*','*', dtStart, dtEnd, 1], @OnResult);
        end;
    2 : begin
          sValue := gDashBoard.Cells[2,gDashBoard.Selection.StartRow];
          wcResources.RawInvoke('IstfmsloadsService.GetPlanResources', ['*','*',sValue, dtStart, dtEnd, 1], @OnResult);
        end;
  else
    wcResources.RawInvoke('IstfmsloadsService.GetPlanResources', ['*','*','*', dtStart, dtEnd, 1], @OnResult);
  end;
end;

procedure TfrmPlanningEnquiry.gDashBoardCellButtonClick(Sender: TObject; ACol,
  ARow: Integer; ACell: TTMSFNCGridCell);
  var
    jsr: TJSDOMRect;
  procedure AfterCreate(AForm : TObject);
    var
      dtlStart,
      dtlEnd : TDate;
      wYear,
      wMonth,
      wDay : Word;
  begin
    with (AForm as TfrmVehicleDetails) do
      begin
        sCompany := gDashBoard.Cells[20,ARow];
        sRegNo := gDashBoard.Cells[2,ARow];
        DecodeDate(dtPicker.Date,wYear,wMonth,wDay);
        dtlStart := EncodeDate(wYear,wMonth,1);
        dtlEnd := EncodeDate(wYear,wMonth,DaysInAMonth(wYear,wMonth));
        dtStart := dtlStart;
        dtEnd := dtlEnd;
        wDateType := 0;
        wType := 0;
        LoadLoadsData;

      end;
  end;

  procedure AfterCreate1(AForm : TObject);
  begin
    (AForm as TfrmFuelOrders).username := frmmain.username;
    (AForm as TfrmFuelOrders).iSystemType := 0;
    (AForm as TfrmFuelOrders).bAllowSearchChange := False;

    (AForm as TfrmFuelOrders).sCompany := gDashBoard.Cells[20,ARow];
    (AForm as TfrmFuelOrders).eSubsCompany.Text := gDashBoard.Cells[0,ARow];

    (AForm as TfrmFuelOrders).sRegNo := gDashBoard.Cells[2,ARow];
    (AForm as TfrmFuelOrders).eRegNo.Text := gDashBoard.Cells[2,ARow];
  end;

begin
  if ACol <= gDashBoard.FixedColumns - 1 then
    Exit;

  if ARow <= gDashBoard.FixedRows - 1 then
    Exit;

  if  ACol = 27 then
    begin
      jsr := document.body.getBoundingClientRect;
      LFrm := TfrmVehicleDetails.CreateNew( @AfterCreate );

      // LFrm als Pop-Up festlegen
      LFrm.Popup := true;

      // Transparenz definieren
      LFrm.PopupOpacity := 0.2;
      LFrm.Height := 463;
      LFrm.Width := 1100;
      LFrm.Top := Round((window.innerheight - LFrm.Height) / 2);
      LFrm.Left := Round((jsr.right - jsr.left - LFrm.Width) / 2);
      LFrm.ShowModal;
    end;

  if  ACol = 28 then
    begin
      LFrm1 := TfrmFuelOrders.CreateNew( @AfterCreate1 );

      // LFrm als Pop-Up festlegen
      LFrm1.Popup := true;

      // Transparenz definieren
      LFrm1.PopupOpacity := 0.2;

      LFrm1.ShowModal;
    end;
end;

procedure TfrmPlanningEnquiry.gDashBoardGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);
  var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar, c, r: Integer;
    f,
    f1,
    f2: TField;
    i: Integer;
    wHour,
    wMin,
    wSec,
    wMSec : Word;
    iTotalHours,
    iFirst,
    iSecond : Integer;
    dtCurrent,
    dtEnd : TDateTime;
    iValue : Real;
begin
  r := ARow;
  c := ACol;

  if (r <= gDashBoard.FixedRows - 1) then
    Exit;

  if (c <= gDashBoard.FixedColumns - 1) then
    Exit;

  try
    if (c = 4) then
      begin
        if Trim(gDashBoard.Cells[c,r]) <> '' then
          begin
            {if gDashBoard.Cells[c,r].ToDouble <
               gDashBoard.Cells[25,r].ToDouble then
              begin
                ALayout.Fill.Color := gcRed;
                ALayout.Font.Style := [fsBold];
                ALayout.Font.Color := clWhite;
              end;}
          end;
      end;
  except

  end;

  try
    if (c = 5) then
      begin
        if Trim(gDashBoard.Cells[c,r]) <> '' then
          begin
            if gDashBoard.Cells[c,r].ToDouble <
               gDashBoard.Cells[26,r].ToDouble then
              begin
                ALayout.Fill.Color := gcRed;
                ALayout.Font.Style := [fsBold];
                ALayout.Font.Color := clWhite;
              end;
          end;
      end;
  except

  end;

  try
    if (c = 6) then
      begin
        if Trim(gDashBoard.Cells[c,r]) <> '' then
          begin
            if (gDashBoard.Cells[c,r].ToDouble <=
                gDashBoard.Cells[23,r].ToDouble) and
               (gDashBoard.Cells[c,r].ToDouble >
                gDashBoard.Cells[24,r].ToDouble)  then
              begin
                ALayout.Fill.Color := gcOrange;
                ALayout.Font.Style := [fsBold];
                ALayout.Font.Color := clWhite;
              end;
            if (gDashBoard.Cells[c,r].ToDouble <
                gDashBoard.Cells[23,r].ToDouble) and
               (gDashBoard.Cells[c,r].ToDouble <=
                gDashBoard.Cells[24,r].ToDouble)  then
              begin
                ALayout.Fill.Color := gcRed;
                ALayout.Font.Style := [fsBold];
                ALayout.Font.Color := clWhite;
              end;
          end;
      end;
  except

  end;

  try
    if (c = 10) then
      begin
        if Trim(gDashBoard.Cells[10,r]) <> '' then
          begin
            iValue := gDashBoard.Cells[10,r].ToDouble;
            if (gDashBoard.Cells[10,r].ToDouble > 2500) and
               (gDashBoard.Cells[10,r].ToDouble <= 5000) then
              begin
                ALayout.Fill.Color := gcYellow;
                ALayout.Font.Style := [fsBold];
              end;

            if (gDashBoard.Cells[10,r].ToDouble <= 2500) then
              begin
                ALayout.Fill.Color := gcRed;
                ALayout.Font.Style := [fsBold];
                ALayout.Font.Color := clWhite;
              end;
          end;
      end;
  except

  end;

  try
    if (c = 11) then
      begin
        if Trim(gDashBoard.Cells[c,r]) <> '' then
          begin
            if (gDashBoard.Cells[c,r].ToInteger >= 2) then
              begin
                ALayout.Fill.Color := gcBlue;
                ALayout.Font.Style := [fsBold];
              end;
          end;
      end;
  except

  end;

  try
    if (c = 12) then
      begin
        if Trim(gDashBoard.Cells[c,r]) <> '' then
          begin
            if (gDashBoard.Cells[c,r].ToInteger > 2) then
              begin
                ALayout.Fill.Color := gcLime;
                ALayout.Font.Style := [fsBold];
              end;
          end;
      end;
  except

  end;

  try
    if (c = 14) then
      begin
        if Trim(gDashBoard.Cells[c,r]) <> '' then
          begin
            iTotalHours := gDashBoard.Cells[17,r].ToInteger;
            dtCurrent := StrToDateTime(gDashBoard.Cells[15,r]);
            dtEnd := StrToDateTime(gDashBoard.Cells[16,r]);
            iFirst := gDashBoard.Cells[18,r].ToInteger;
            iSecond := gDashBoard.Cells[19,r].ToInteger;
            if dtEnd > dtCurrent then
              begin
                if (iTotalHours <= iFirst) and (iTotalHours > iSecond) then
                  begin
                    ALayout.Fill.Color := gcYellow;
                    ALayout.Font.Style := [fsBold];
                    ALayout.Font.Color := gcBlack;
                  end;
                if (iTotalHours <= iSecond) and (iTotalHours > 0) then
                  begin
                    ALayout.Fill.Color := gcOrange;
                    ALayout.Font.Style := [fsBold];
                    ALayout.Font.Color := gcWhite;
                  end;
              end;
            if dtEnd <= dtCurrent then
              begin
                ALayout.Fill.Color := gcRed;
                ALayout.Font.Style := [fsBold];
                ALayout.Font.Color := gcWhite;
              end;
          end;
      end;
  except

  end;

  try
    if (c = 27) then
      begin
        gDashBoard.AddButton(c,r,'Income Details', 85, 22)
      end;
  except

  end;

  try
    if (c = 28) then
      begin
        gDashBoard.AddButton(c,r,'Diesel Orders', 85, 22)
      end;
  except

  end;
end;

procedure TfrmPlanningEnquiry.gDashBoardSortFormat(Sender: TObject;
  Col: Integer; var SortFormat: TTMSFNCGridSortFormat; var APrefix,
  ASuffix: string);
begin
  case Col of
    0 : SortFormat := ssAlphabeticNoCase;
    1 : SortFormat := ssAlphabeticNoCase;
    2 : SortFormat := ssAlphabeticNoCase;
    3 : SortFormat := ssNumeric;
    4 : SortFormat := ssNumeric;
    5 : SortFormat := ssNumeric;
    6 : SortFormat := ssNumeric;
    7 : SortFormat := ssNumeric;
    10 : SortFormat := ssNumeric;
  end;
end;

procedure TfrmPlanningEnquiry.GetPlannerData;
  var
    sValue : String;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    qPlanning.Close;
    qPlanning.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    qPlanning.Open;
  end;
begin
  Case gDashBoard.Selection.StartCol of
    0 : begin
          sValue := gDashBoard.Cells[20,gDashBoard.Selection.StartRow];
          wcPlanning.RawInvoke('IstfmsloadsService.GetPlanning', ['*',sValue,'*', dtStart, dtEnd, 1], @OnResult);
        end;
    1 : begin
          sValue := gDashBoard.Cells[21,gDashBoard.Selection.StartRow];
          wcPlanning.RawInvoke('IstfmsloadsService.GetPlanning', [sValue,'*','*', dtStart, dtEnd, 1], @OnResult);
        end;
    2 : begin
          sValue := gDashBoard.Cells[2,gDashBoard.Selection.StartRow];
          wcPlanning.RawInvoke('IstfmsloadsService.GetPlanning', ['*','*',sValue, dtStart, dtEnd, 1], @OnResult);
        end;
  else
    wcPlanning.RawInvoke('IstfmsloadsService.GetPlanning', ['*','*','*', dtStart, dtEnd, 1], @OnResult);
  end;

end;

procedure TfrmPlanningEnquiry.lCompanyKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if Key = VK_Delete then
    begin
      lCompany.Text := '';
      sCompany := '';
    end;
end;

procedure TfrmPlanningEnquiry.lControllerKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if Key = VK_Delete then
    begin
      lController.Text := '';
      sController := '';
    end;
end;

procedure TfrmPlanningEnquiry.lGroupKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if Key = VK_Delete then
    begin
      lGroup.Text := '';
      sGroup := '';
    end;
end;

procedure TfrmPlanningEnquiry.lRegNoKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if Key = VK_Delete then
    begin
      lRegNo.Text := '';
      sRegNo := '';
    end;
end;

procedure TfrmPlanningEnquiry.pPlannerAfterDrawItem(Sender: TObject;
  AGraphics: TTMSFNCGraphics; ARect: TRectF; AItem: TTMSFNCPlannerItem);
begin
  if AItem.DBKey <> '' then
    begin
      If qPlanning.Locate('No', AItem.DBKey, [loCaseInsensitive, loPartialKey]) then
        begin
          if (qPlanning.FieldByName('Loaded').AsBoolean) and not(qPlanning.FieldByName('OffLoaded').asBoolean) and
             not(qPlanning.FieldByName('CInvoiced').AsBoolean) then
            begin
              AItem.Color := clBlue;
              AItem.FontColor := clWhite;
            end;
          if (qPlanning.FieldByName('Loaded').AsBoolean) and (qPlanning.FieldByName('OffLoaded').asBoolean) and
             not(qPlanning.FieldByName('CInvoiced').AsBoolean) then
            begin
              AItem.Color := clYellow;
              AItem.FontColor := clBlack;
            end;
          if (qPlanning.FieldByName('CInvoiced').AsBoolean) then
            begin
              AItem.Color := clLime;
              AItem.FontColor := clBlack;
            end;
        end;
    end;
end;

procedure TfrmPlanningEnquiry.pPlannerAfterNavigateToDateTime(Sender: TObject;
  ADirection: TTMSFNCPlannerNavigationDirection; ACurrentDateTime,
  ANewDateTime: TDateTime);
begin
  //pdaPlanner.LoadItems;
end;

procedure TfrmPlanningEnquiry.qDashBoardAfterOpen(DataSet: TDataSet);
begin
  gdaDashBoard.Active := True;

  TFloatField(qDashBoard.FieldByName('revenu')).DisplayFormat := '#,##0.00';
  TFloatField(qDashBoard.FieldByName('surplus')).DisplayFormat := '#,##0.00';
  TFloatField(qDashBoard.FieldByName('dayaverage')).DisplayFormat := '#,##0.00';
  TFloatField(qDashBoard.FieldByName('fuelconsumption')).DisplayFormat := '#,##0.00';
  TIntegerField(qDashBoard.FieldByName('kilosnextservice')).DisplayFormat := '#,##0';

  gdaDashBoard.LoadAllDataAndDisconnect;
end;

procedure TfrmPlanningEnquiry.qPlanningAfterOpen(DataSet: TDataSet);
begin
  pdaPlanner.Active := True;
  WebWaitMessage1.Hide;
end;

procedure TfrmPlanningEnquiry.qResourcesAfterOpen(DataSet: TDataSet);
  var
    res: TTMSFNCPlannerResource;
    wYear,
    wMonth,
    wDay : Word;
begin
  pPlanner.BeginUpdate;
  pPlanner.Resources.Clear;
  qResources.First;
  Repeat
    res := pPlanner.Resources.Add;
    res.Name := qResources.FieldByName('RegNo').asString;
    res.Text := qResources.FieldByName('RegNo').asString;
    //res.Text := qResources.FieldByName('RegNo').asString;
    qResources.Next;
  Until qResources.Eof;
  pPlanner.Positions.Count := pPlanner.Resources.Count;
  pPlanner.Positions.Format := 'dd/MM/yyyy';
  DecodeDate(dtStart,wYear,wMonth,wDay);
  pPlanner.ModeSettings.StartTime := EncodeDateTime(wYear,wMonth,wDay,0,0,0,0);
  DecodeDate(dtEnd,wYear,wMonth,wDay);
  pPlanner.ModeSettings.EndTime := EncodeDateTime(wYear,wMonth,wDay,23,59,59,59);
  pPlanner.EndUpdate;
  GetPlannerData;
end;

procedure TfrmPlanningEnquiry.qTotalsAfterOpen(DataSet: TDataSet);
begin
  weCount.Text := FormatFloat('0', qTotals.FieldByName('count').asInteger);
  weTotalRev.Text := FormatFloat('#,##0.00', qTotals.FieldByName('revenue').asFloat);
  weTotalSurplus.Text := FormatFloat('#,##0.00', qTotals.FieldByName('surplus').asFloat);
  weAvgDay.Text := FormatFloat('#,##0.00', qTotals.FieldByName('dayaverage').asFloat);
  weAvgFuel.Text := FormatFloat('#,##0.00', qTotals.FieldByName('fuel').asFloat);
end;

procedure TfrmPlanningEnquiry.TMSFNCPageControl1ChangePage(Sender: TObject;
  APreviousPageIndex, ACurrentPageIndex: Integer);
begin
  case ACurrentPageIndex of
    0 : begin
          WebTimer1.Enabled := True;
        end;
    1 : begin
          WebTimer1.Enabled := False;
          dtStart := dtPicker.Date - 3;
          dtEnd := dtPicker.Date + 4;
          DoGetDataShowScreen;
        end;
  end;
end;

procedure TfrmPlanningEnquiry.WebFormResize(Sender: TObject);
  var
    jsr: TJSDOMRect;
begin
  if assigned(LFrm) then
    begin
      jsr := document.body.getBoundingClientRect;

      LFrm.Height := 463;
      LFrm.Width := 1100;
      LFrm.Top := Round((window.innerheight - LFrm.Height) / 2);
      LFrm.Left := Round((jsr.right - jsr.left - LFrm.Width) / 2);
    end;
end;

procedure TfrmPlanningEnquiry.WebFormShow(Sender: TObject);
begin
  sCompany := '';
  dtPicker.Date := Date;
  //WebWaitMessage1.Show;
  //DoGetDashBoardData;
end;

procedure TfrmPlanningEnquiry.WebSpeedButton1Click(Sender: TObject);
begin
  dtStart := dtStart - 1;
  dtEnd := dtEnd - 1;
  DoGetDataShowScreen;
end;

procedure TfrmPlanningEnquiry.WebSpeedButton2Click(Sender: TObject);
begin
  dtStart := dtStart + 1;
  dtEnd := dtEnd + 1;
  DoGetDataShowScreen;
end;

procedure TfrmPlanningEnquiry.WebSpeedButton3Click(Sender: TObject);
  var
    LFrm : TfrmSearchSubs;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if sCode <> '' then
          begin
            lCompany.Text := sName;
            sCompany := sCode;
          end
        else
          begin
            lCompany.Text := '';
            sCompany := '';
          end;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmSearchSubs) do
      begin
        bSuspended := True;
        iType := 0;
        GetData;

      end;
  end;
begin
  LFrm := TfrmSearchSubs.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmPlanningEnquiry.WebSpeedButton4Click(Sender: TObject);
  var
    LFrm : TfrmSearchVehgroups;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if sCode <> '' then
          begin
            lGroup.Text := sName;
            sGroup := sCode;
          end
        else
          begin
            lGroup.Text := '';
            sGroup := '';
          end;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmSearchVehgroups) do
      begin
        bSuspended := True;
        GetData;
      end;
  end;
begin
  LFrm := TfrmSearchVehgroups.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmPlanningEnquiry.WebSpeedButton5Click(Sender: TObject);
  var
    LFrm : TfrmSearchReg;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if sCode <> '' then
          begin
            lRegNo.Text := sName;
            sRegNo := sCode;
          end
        else
          begin
            lRegNo.Text := '';
            sRegNo := '';
          end;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmSearchReg) do
      begin
        bSuspended := True;
        GetData;
      end;
  end;
begin
  LFrm := TfrmSearchReg.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmPlanningEnquiry.WebSpeedButton6Click(Sender: TObject);
  var
    LFrm : TfrmSearchController;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if sCode <> '' then
          begin
            lController.Text := sName;
            sController := sCode;
          end
        else
          begin
            lController.Text := '';
            sController := '';
          end;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmSearchController) do
      begin
        bSuspended := True;
        GetData;
      end;
  end;
begin
  LFrm := TfrmSearchController.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmPlanningEnquiry.WebTimer1Timer(Sender: TObject);
begin
  DoGetDashBoardData;
end;

procedure TfrmPlanningEnquiry.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  gdaDashBoard := TTMSFNCGridDatabaseAdapter.Create(Self);
  TMSFNCPageControl1 := TTMSFNCPageControl.Create(Self);
  TMSFNCPageControl1Page2 := TTMSFNCPageControlContainer.Create(Self);
  TMSFNCPageControl1Page1 := TTMSFNCPageControlContainer.Create(Self);
  TMSFNCPageControl1Page0 := TTMSFNCPageControlContainer.Create(Self);
  pPlanner := TTMSFNCPlanner.Create(Self);
  pdaPlanner := TTMSFNCPlannerDatabaseAdapter.Create(Self);
  wpLoadsButtons := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  wpLoadsAdd := TPanel.Create(Self);
  WebWaitMessage1 := TWaitMessage.Create(Self);
  TMSFNCPageControl1Page3 := TTMSFNCPageControlContainer.Create(Self);
  gDashBoard := TTMSFNCGrid.Create(Self);
  WebMessageDlg1 := TMessageDlg.Create(Self);
  sbBottom := TScrollBox.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  weCount := TEdit.Create(Self);
  weTotalRev := TEdit.Create(Self);
  weTotalSurplus := TEdit.Create(Self);
  weAvgDay := TEdit.Create(Self);
  weAvgFuel := TEdit.Create(Self);
  sbDashBoard := TScrollBox.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  lCompany := TEdit.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  lGroup := TEdit.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  lRegNo := TEdit.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  lController := TEdit.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  dtPicker := TDateTimePicker.Create(Self);
  btnSearch := TSpeedButton.Create(Self);
  wcPlanning := TXDataWebClient.Create(Self);
  qPlanning := TXDataWebDataSet.Create(Self);
  qPlanningNo := TIntegerField.Create(Self);
  qPlanningRegSource := TIntegerField.Create(Self);
  qPlanningRegNo := TStringField.Create(Self);
  qPlanningContractNo := TIntegerField.Create(Self);
  qPlanningContractName := TStringField.Create(Self);
  qPlanningSubCode := TStringField.Create(Self);
  qPlanningSubName := TStringField.Create(Self);
  qPlanningCanceled := TBooleanField.Create(Self);
  qPlanningLoaded := TBooleanField.Create(Self);
  qPlanningOffLoaded := TBooleanField.Create(Self);
  qPlanningLoadconno := TIntegerField.Create(Self);
  qPlanningCInvoiceNo := TStringField.Create(Self);
  qPlanningCInvoiced := TBooleanField.Create(Self);
  qPlanningSInvoiceNo := TStringField.Create(Self);
  qPlanningSInvoiced := TBooleanField.Create(Self);
  qPlanningLoadStandTime := TTimeField.Create(Self);
  qPlanningOffLoadStandTime := TTimeField.Create(Self);
  qPlanningTrafelTime := TTimeField.Create(Self);
  qPlanningTimeLeft := TTimeField.Create(Self);
  qPlanningLoadingDate := TDateTimeField.Create(Self);
  qPlanningOffLoadingDate := TDateTimeField.Create(Self);
  qPlanningSystemType := TStringField.Create(Self);
  dsPlanning := TDataSource.Create(Self);
  qResources := TXDataWebDataSet.Create(Self);
  qResourcesNo := TIntegerField.Create(Self);
  qResourcesRegNo := TStringField.Create(Self);
  dsResources := TDataSource.Create(Self);
  wcResources := TXDataWebClient.Create(Self);
  WebTimer1 := TTimer.Create(Self);
  qDashBoard := TXDataWebDataSet.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  StringField1 := TStringField.Create(Self);
  qDashBoardSubCode := TStringField.Create(Self);
  qDashBoardSubName := TStringField.Create(Self);
  qDashBoardLoadsNotStarted := TIntegerField.Create(Self);
  qDashBoardLoadsStarted := TIntegerField.Create(Self);
  qDashBoardKilos := TIntegerField.Create(Self);
  qDashBoardLastKilosService := TIntegerField.Create(Self);
  qDashBoardKilosNextService := TIntegerField.Create(Self);
  qDashBoardDieselOrder := TIntegerField.Create(Self);
  qDashBoardWarnings := TIntegerField.Create(Self);
  qDashBoardLastLoadStart := TStringField.Create(Self);
  qDashBoardLastLoadPlan := TStringField.Create(Self);
  qDashBoardLastDieselOrder := TStringField.Create(Self);
  qDashBoardLoadEndTime := TDateTimeField.Create(Self);
  qDashBoardCurrentTime := TDateTimeField.Create(Self);
  qDashBoardTotalHours := TIntegerField.Create(Self);
  qDashBoardTimeLeft := TStringField.Create(Self);
  qDashBoardFirstwarning := TIntegerField.Create(Self);
  qDashBoardSecondwarning := TIntegerField.Create(Self);
  qDashBoardGroupNo := TIntegerField.Create(Self);
  qDashBoardGroupName := TStringField.Create(Self);
  qDashBoardRevenu := TFloatField.Create(Self);
  qDashBoardSurplus := TFloatField.Create(Self);
  qDashBoardDayAverage := TFloatField.Create(Self);
  qDashBoardDayGood := TFloatField.Create(Self);
  qDashBoardDayFirst := TFloatField.Create(Self);
  qDashBoardDaySecond := TFloatField.Create(Self);
  qDashBoardRevToDate := TFloatField.Create(Self);
  qDashBoardSurplusToDate := TFloatField.Create(Self);
  qDashBoardFuelConsumption := TFloatField.Create(Self);
  qDashBoardLoadCount := TIntegerField.Create(Self);
  qDashBoardSurplusPerc := TFloatField.Create(Self);
  dsDashBoard := TDataSource.Create(Self);
  wcDashBoard := TXDataWebClient.Create(Self);
  qTotals := TXDataWebDataSet.Create(Self);
  qTotalsCount := TIntegerField.Create(Self);
  qTotalsRevenue := TFloatField.Create(Self);
  qTotalsSurplus := TFloatField.Create(Self);
  qTotalsDayAverage := TFloatField.Create(Self);
  qTotalsFuel := TFloatField.Create(Self);
  dsTotals := TDataSource.Create(Self);
  wcTotals := TXDataWebClient.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  gdaDashBoard.BeforeLoadDFMValues;
  TMSFNCPageControl1.BeforeLoadDFMValues;
  TMSFNCPageControl1Page2.BeforeLoadDFMValues;
  TMSFNCPageControl1Page1.BeforeLoadDFMValues;
  TMSFNCPageControl1Page0.BeforeLoadDFMValues;
  pPlanner.BeforeLoadDFMValues;
  pdaPlanner.BeforeLoadDFMValues;
  wpLoadsButtons.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  wpLoadsAdd.BeforeLoadDFMValues;
  WebWaitMessage1.BeforeLoadDFMValues;
  TMSFNCPageControl1Page3.BeforeLoadDFMValues;
  gDashBoard.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  sbBottom.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  weCount.BeforeLoadDFMValues;
  weTotalRev.BeforeLoadDFMValues;
  weTotalSurplus.BeforeLoadDFMValues;
  weAvgDay.BeforeLoadDFMValues;
  weAvgFuel.BeforeLoadDFMValues;
  sbDashBoard.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  lCompany.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  lGroup.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  lRegNo.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  lController.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  dtPicker.BeforeLoadDFMValues;
  btnSearch.BeforeLoadDFMValues;
  wcPlanning.BeforeLoadDFMValues;
  qPlanning.BeforeLoadDFMValues;
  qPlanningNo.BeforeLoadDFMValues;
  qPlanningRegSource.BeforeLoadDFMValues;
  qPlanningRegNo.BeforeLoadDFMValues;
  qPlanningContractNo.BeforeLoadDFMValues;
  qPlanningContractName.BeforeLoadDFMValues;
  qPlanningSubCode.BeforeLoadDFMValues;
  qPlanningSubName.BeforeLoadDFMValues;
  qPlanningCanceled.BeforeLoadDFMValues;
  qPlanningLoaded.BeforeLoadDFMValues;
  qPlanningOffLoaded.BeforeLoadDFMValues;
  qPlanningLoadconno.BeforeLoadDFMValues;
  qPlanningCInvoiceNo.BeforeLoadDFMValues;
  qPlanningCInvoiced.BeforeLoadDFMValues;
  qPlanningSInvoiceNo.BeforeLoadDFMValues;
  qPlanningSInvoiced.BeforeLoadDFMValues;
  qPlanningLoadStandTime.BeforeLoadDFMValues;
  qPlanningOffLoadStandTime.BeforeLoadDFMValues;
  qPlanningTrafelTime.BeforeLoadDFMValues;
  qPlanningTimeLeft.BeforeLoadDFMValues;
  qPlanningLoadingDate.BeforeLoadDFMValues;
  qPlanningOffLoadingDate.BeforeLoadDFMValues;
  qPlanningSystemType.BeforeLoadDFMValues;
  dsPlanning.BeforeLoadDFMValues;
  qResources.BeforeLoadDFMValues;
  qResourcesNo.BeforeLoadDFMValues;
  qResourcesRegNo.BeforeLoadDFMValues;
  dsResources.BeforeLoadDFMValues;
  wcResources.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  qDashBoard.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  qDashBoardSubCode.BeforeLoadDFMValues;
  qDashBoardSubName.BeforeLoadDFMValues;
  qDashBoardLoadsNotStarted.BeforeLoadDFMValues;
  qDashBoardLoadsStarted.BeforeLoadDFMValues;
  qDashBoardKilos.BeforeLoadDFMValues;
  qDashBoardLastKilosService.BeforeLoadDFMValues;
  qDashBoardKilosNextService.BeforeLoadDFMValues;
  qDashBoardDieselOrder.BeforeLoadDFMValues;
  qDashBoardWarnings.BeforeLoadDFMValues;
  qDashBoardLastLoadStart.BeforeLoadDFMValues;
  qDashBoardLastLoadPlan.BeforeLoadDFMValues;
  qDashBoardLastDieselOrder.BeforeLoadDFMValues;
  qDashBoardLoadEndTime.BeforeLoadDFMValues;
  qDashBoardCurrentTime.BeforeLoadDFMValues;
  qDashBoardTotalHours.BeforeLoadDFMValues;
  qDashBoardTimeLeft.BeforeLoadDFMValues;
  qDashBoardFirstwarning.BeforeLoadDFMValues;
  qDashBoardSecondwarning.BeforeLoadDFMValues;
  qDashBoardGroupNo.BeforeLoadDFMValues;
  qDashBoardGroupName.BeforeLoadDFMValues;
  qDashBoardRevenu.BeforeLoadDFMValues;
  qDashBoardSurplus.BeforeLoadDFMValues;
  qDashBoardDayAverage.BeforeLoadDFMValues;
  qDashBoardDayGood.BeforeLoadDFMValues;
  qDashBoardDayFirst.BeforeLoadDFMValues;
  qDashBoardDaySecond.BeforeLoadDFMValues;
  qDashBoardRevToDate.BeforeLoadDFMValues;
  qDashBoardSurplusToDate.BeforeLoadDFMValues;
  qDashBoardFuelConsumption.BeforeLoadDFMValues;
  qDashBoardLoadCount.BeforeLoadDFMValues;
  qDashBoardSurplusPerc.BeforeLoadDFMValues;
  dsDashBoard.BeforeLoadDFMValues;
  wcDashBoard.BeforeLoadDFMValues;
  qTotals.BeforeLoadDFMValues;
  qTotalsCount.BeforeLoadDFMValues;
  qTotalsRevenue.BeforeLoadDFMValues;
  qTotalsSurplus.BeforeLoadDFMValues;
  qTotalsDayAverage.BeforeLoadDFMValues;
  qTotalsFuel.BeforeLoadDFMValues;
  dsTotals.BeforeLoadDFMValues;
  wcTotals.BeforeLoadDFMValues;
  try
    Name := 'frmPlanningEnquiry';
    Width := 1706;
    Height := 652;
    Align := alClient;
    Color := clSilver;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.AlignWithMargins := True;
    WebLabel1.Left := 3;
    WebLabel1.Top := 3;
    WebLabel1.Width := 1700;
    WebLabel1.Height := 32;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := 'Fleet Planning';
    WebLabel1.Color := clSilver;
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.Layout := tlCenter;
    WebLabel1.WidthPercent := 100.000000000000000000;
    gdaDashBoard.SetParentComponent(Self);
    gdaDashBoard.Name := 'gdaDashBoard';
    gdaDashBoard.Left := 784;
    gdaDashBoard.Top := 21;
    gdaDashBoard.Width := 26;
    gdaDashBoard.Height := 26;
    gdaDashBoard.Visible := True;
    gdaDashBoard.Grid := gDashBoard;
    gdaDashBoard.DataSource := dsDashBoard;
    gdaDashBoard.Columns.Clear;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'SubName';
      Header := 'Company';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'GroupName';
      Header := 'Group Name';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'RegNo';
      Header := 'Reg No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'LoadCount';
      Header := 'Load Count';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'Revenu';
      Header := 'Revenu       ';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'Surplus';
      Header := 'Surplus       ';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'DayAverage';
      Header := 'Day        Average       ';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'FuelConsumption';
      Header := 'K/Liter       ';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'Kilos';
      Header := 'Last Kilos';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'LastKilosService';
      Header := 'Last Service';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'KilosNextService';
      Header := 'Kilos To        Service       ';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'LoadsNotStarted';
      Header := 'Loads Not       Loaded';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'LoadsStarted';
      Header := 'Loads    Loaded       ';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'LastLoadStart';
      Header := 'Last Load';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'TimeLeft';
      Header := 'Time Left For Last Load';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'CurrentTime';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'LoadEndTime';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'TotalHours';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'Firstwarning';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'Secondwarning';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'SubCode';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'GroupNo';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'DayGood';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'DayFirst';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'DaySecond';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'RevToDate';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      FieldName := 'SurplusToDate';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      Header := 'Income';
      CheckFalse := 'False';
      UseLookupEditor := False;
      CheckTrue := 'True';
    end;
    with gdaDashBoard.Columns.Add do
    begin
      Header := 'Diesel Orders';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    gdaDashBoard.AutoCreateColumns := False;
    TMSFNCPageControl1.SetParentComponent(Self);
    TMSFNCPageControl1.Name := 'TMSFNCPageControl1';
    TMSFNCPageControl1.AlignWithMargins := True;
    TMSFNCPageControl1.Left := 3;
    TMSFNCPageControl1.Top := 41;
    TMSFNCPageControl1.Width := 1700;
    TMSFNCPageControl1.Height := 608;
    TMSFNCPageControl1.AdaptToStyle := True;
    TMSFNCPageControl1.Align := alClient;
    TMSFNCPageControl1.ParentDoubleBuffered := False;
    TMSFNCPageControl1.Color := clBtnFace;
    TMSFNCPageControl1.DoubleBuffered := True;
    TMSFNCPageControl1.Font.Charset := DEFAULT_CHARSET;
    TMSFNCPageControl1.Font.Color := clWindowText;
    TMSFNCPageControl1.Font.Height := -15;
    TMSFNCPageControl1.Font.Name := 'Tahoma';
    TMSFNCPageControl1.Font.Style := [];
    TMSFNCPageControl1.ParentFont := False;
    TMSFNCPageControl1.TabOrder := 1;
    TMSFNCPageControl1.Fill.Kind := gfkNone;
    TMSFNCPageControl1.Stroke.Kind := gskNone;
    TMSFNCPageControl1.Stroke.Color := 15987699;
    TMSFNCPageControl1.TabAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCPageControl1.TabAppearance.Font.Color := clWindowText;
    TMSFNCPageControl1.TabAppearance.Font.Height := -11;
    TMSFNCPageControl1.TabAppearance.Font.Name := 'Segoe UI';
    TMSFNCPageControl1.TabAppearance.Font.Style := [];
    TMSFNCPageControl1.TabAppearance.Fill.Color := 15385233;
    TMSFNCPageControl1.TabAppearance.Stroke.Color := 15987699;
    TMSFNCPageControl1.TabAppearance.ActiveStroke.Color := 15987699;
    TMSFNCPageControl1.TabAppearance.DownFill.Color := 15119995;
    TMSFNCPageControl1.TabAppearance.DownStroke.Color := 15987699;
    TMSFNCPageControl1.TabAppearance.HoverFill.Color := 15650471;
    TMSFNCPageControl1.TabAppearance.HoverStroke.Color := 15987699;
    TMSFNCPageControl1.TabAppearance.TextSpacing := 0.000000000000000000;
    TMSFNCPageControl1.TabAppearance.ShowFocus := False;
    TMSFNCPageControl1.TabAppearance.CloseStroke.Width := 2.000000000000000000;
    TMSFNCPageControl1.TabAppearance.CloseDownStroke.Width := 2.000000000000000000;
    TMSFNCPageControl1.TabAppearance.CloseHoverStroke.Width := 2.000000000000000000;
    TMSFNCPageControl1.TabAppearance.BadgeFill.Color := 15385233;
    TMSFNCPageControl1.TabAppearance.BadgeFont.Charset := DEFAULT_CHARSET;
    TMSFNCPageControl1.TabAppearance.BadgeFont.Color := clDarkred;
    TMSFNCPageControl1.TabAppearance.BadgeFont.Height := -11;
    TMSFNCPageControl1.TabAppearance.BadgeFont.Name := 'Segoe UI';
    TMSFNCPageControl1.TabAppearance.BadgeFont.Style := [fsBold];
    TMSFNCPageControl1.ButtonAppearance.Fill.Color := 15385233;
    TMSFNCPageControl1.ButtonAppearance.Stroke.Color := 15987699;
    TMSFNCPageControl1.ButtonAppearance.DownFill.Color := 15119995;
    TMSFNCPageControl1.ButtonAppearance.DownStroke.Color := 15987699;
    TMSFNCPageControl1.ButtonAppearance.HoverFill.Color := 15650471;
    TMSFNCPageControl1.ButtonAppearance.HoverStroke.Color := 15987699;
    TMSFNCPageControl1.ButtonAppearance.CloseIcon.LoadFromFile('planning.enquiry.TMSFNCPageControl1.ButtonAppearance.CloseIcon.svg');
    TMSFNCPageControl1.ButtonAppearance.InsertIcon.LoadFromFile('planning.enquiry.TMSFNCPageControl1.ButtonAppearance.InsertIcon.svg');
    TMSFNCPageControl1.ButtonAppearance.TabListIcon.LoadFromFile('planning.enquiry.TMSFNCPageControl1.ButtonAppearance.TabListIcon.svg');
    TMSFNCPageControl1.ButtonAppearance.ScrollNextIcon.LoadFromFile('planning.enquiry.TMSFNCPageControl1.ButtonAppearance.ScrollNextIcon.svg');
    TMSFNCPageControl1.ButtonAppearance.ScrollPreviousIcon.LoadFromFile('planning.enquiry.TMSFNCPageControl1.ButtonAppearance.ScrollPreviousIcon.svg');
    TMSFNCPageControl1.TabSize.Margins.Left := 8.000000000000000000;
    TMSFNCPageControl1.TabSize.Margins.Top := 8.000000000000000000;
    TMSFNCPageControl1.TabSize.Margins.Right := 8.000000000000000000;
    TMSFNCPageControl1.TabSize.Margins.Bottom := 8.000000000000000000;
    TMSFNCPageControl1.Pages.Clear;
    with TMSFNCPageControl1.Pages.Add do
    begin
      Text := 'DASH BOARD';
      UseDefaultAppearance := True;
    end;
    with TMSFNCPageControl1.Pages.Add do
    begin
      Text := 'LOADS';
      UseDefaultAppearance := True;
    end;
    with TMSFNCPageControl1.Pages.Add do
    begin
      Text := 'FUEL';
      UseDefaultAppearance := True;
    end;
    with TMSFNCPageControl1.Pages.Add do
    begin
      Text := 'MAINTENANCE';
      UseDefaultAppearance := True;
    end;
    SetEvent(TMSFNCPageControl1, Self, 'OnChangePage', 'TMSFNCPageControl1ChangePage');
    TMSFNCPageControl1Page2.SetParentComponent(TMSFNCPageControl1);
    TMSFNCPageControl1Page2.Name := 'TMSFNCPageControl1Page2';
    TMSFNCPageControl1Page2.AlignWithMargins := True;
    TMSFNCPageControl1Page2.Left := 0;
    TMSFNCPageControl1Page2.Top := 29;
    TMSFNCPageControl1Page2.Width := 1700;
    TMSFNCPageControl1Page2.Height := 579;
    TMSFNCPageControl1Page2.Margins.Left := 0;
    TMSFNCPageControl1Page2.Margins.Top := 29;
    TMSFNCPageControl1Page2.Margins.Right := 0;
    TMSFNCPageControl1Page2.Margins.Bottom := 0;
    TMSFNCPageControl1Page2.AdaptToStyle := True;
    TMSFNCPageControl1Page2.Align := alClient;
    TMSFNCPageControl1Page2.ParentDoubleBuffered := False;
    TMSFNCPageControl1Page2.DoubleBuffered := True;
    TMSFNCPageControl1Page2.TabStop := False;
    TMSFNCPageControl1Page2.TabOrder := 2;
    TMSFNCPageControl1Page2.Visible := False;
    TMSFNCPageControl1Page2.Stroke.Color := 15987699;
    TMSFNCPageControl1Page2.PageIndex := 3;
    TMSFNCPageControl1Page2.IsActive := False;
    TMSFNCPageControl1Page1.SetParentComponent(TMSFNCPageControl1);
    TMSFNCPageControl1Page1.Name := 'TMSFNCPageControl1Page1';
    TMSFNCPageControl1Page1.AlignWithMargins := True;
    TMSFNCPageControl1Page1.Left := 0;
    TMSFNCPageControl1Page1.Top := 29;
    TMSFNCPageControl1Page1.Width := 1700;
    TMSFNCPageControl1Page1.Height := 579;
    TMSFNCPageControl1Page1.Margins.Left := 0;
    TMSFNCPageControl1Page1.Margins.Top := 29;
    TMSFNCPageControl1Page1.Margins.Right := 0;
    TMSFNCPageControl1Page1.Margins.Bottom := 0;
    TMSFNCPageControl1Page1.AdaptToStyle := True;
    TMSFNCPageControl1Page1.Align := alClient;
    TMSFNCPageControl1Page1.ParentDoubleBuffered := False;
    TMSFNCPageControl1Page1.DoubleBuffered := True;
    TMSFNCPageControl1Page1.TabStop := False;
    TMSFNCPageControl1Page1.TabOrder := 1;
    TMSFNCPageControl1Page1.Visible := False;
    TMSFNCPageControl1Page1.Stroke.Color := 15987699;
    TMSFNCPageControl1Page1.PageIndex := 2;
    TMSFNCPageControl1Page1.IsActive := False;
    TMSFNCPageControl1Page0.SetParentComponent(TMSFNCPageControl1);
    TMSFNCPageControl1Page0.Name := 'TMSFNCPageControl1Page0';
    TMSFNCPageControl1Page0.AlignWithMargins := True;
    TMSFNCPageControl1Page0.Left := 0;
    TMSFNCPageControl1Page0.Top := 29;
    TMSFNCPageControl1Page0.Width := 1700;
    TMSFNCPageControl1Page0.Height := 579;
    TMSFNCPageControl1Page0.Margins.Left := 0;
    TMSFNCPageControl1Page0.Margins.Top := 29;
    TMSFNCPageControl1Page0.Margins.Right := 0;
    TMSFNCPageControl1Page0.Margins.Bottom := 0;
    TMSFNCPageControl1Page0.AdaptToStyle := True;
    TMSFNCPageControl1Page0.Align := alClient;
    TMSFNCPageControl1Page0.ParentDoubleBuffered := False;
    TMSFNCPageControl1Page0.DoubleBuffered := True;
    TMSFNCPageControl1Page0.TabStop := False;
    TMSFNCPageControl1Page0.TabOrder := 0;
    TMSFNCPageControl1Page0.Visible := False;
    TMSFNCPageControl1Page0.Stroke.Color := 15987699;
    TMSFNCPageControl1Page0.PageIndex := 1;
    TMSFNCPageControl1Page0.IsActive := False;
    pPlanner.SetParentComponent(TMSFNCPageControl1Page0);
    pPlanner.Name := 'pPlanner';
    pPlanner.Left := 0;
    pPlanner.Top := 41;
    pPlanner.Width := 1183;
    pPlanner.Height := 538;
    pPlanner.Align := alClient;
    pPlanner.ParentDoubleBuffered := False;
    pPlanner.Color := 16380654;
    pPlanner.DoubleBuffered := True;
    pPlanner.TabOrder := 0;
    pPlanner.Adapter := pdaPlanner;
    pPlanner.DefaultItem.Text := 'Sample text for this item.';
    pPlanner.DefaultItem.Title := 'Item Title';
    pPlanner.DefaultItem.StartTime := 45208.270833333340000000;
    pPlanner.DefaultItem.EndTime := 45208.375000000000000000;
    pPlanner.DefaultItem.StrokeColor := clDarkgray;
    pPlanner.DefaultItem.TitleStrokeColor := clDarkgray;
    pPlanner.DefaultItem.SelectedColor := 15776936;
    pPlanner.DefaultItem.SelectedStrokeColor := 15106394;
    pPlanner.DefaultItem.ActiveColor := 15776936;
    pPlanner.DefaultItem.ActiveStrokeColor := 15106394;
    pPlanner.DefaultItem.FontColor := 8026746;
    pPlanner.DefaultItem.TitleFontColor := 4539717;
    pPlanner.DefaultItem.ActiveFontColor := 4539717;
    pPlanner.DefaultItem.ActiveTitleFontColor := 4539717;
    pPlanner.DefaultItem.MarkType := [imtTop];
    pPlanner.DefaultItem.MarkColor := 15106394;
    pPlanner.DefaultItem.MarkSizeTop := 8.000000000000000000;
    pPlanner.DefaultItem.MarkRounding := 3;
    pPlanner.DefaultItem.MarkCorners := [gcTopLeft,gcTopRight];
    pPlanner.DefaultItem.Rounding := 3;
    pPlanner.DefaultItem.RoundingCorners := [gcTopLeft,gcTopRight,gcBottomLeft,gcBottomRight];
    pPlanner.GridCellAppearance.HorizontalSubStroke.Color := 13816015;
    pPlanner.GridCellAppearance.InActiveFill.Color := 16711679;
    pPlanner.GridCellAppearance.Fill.Color := 16578806;
    pPlanner.GroupsAppearance.TopSize := 50.000000000000000000;
    pPlanner.GroupsAppearance.BottomSize := 50.000000000000000000;
    pPlanner.GroupsAppearance.TopFont.Charset := DEFAULT_CHARSET;
    pPlanner.GroupsAppearance.TopFont.Color := clGray;
    pPlanner.GroupsAppearance.TopFont.Height := -11;
    pPlanner.GroupsAppearance.TopFont.Name := 'Segoe UI';
    pPlanner.GroupsAppearance.TopFont.Style := [];
    pPlanner.GroupsAppearance.BottomFont.Charset := DEFAULT_CHARSET;
    pPlanner.GroupsAppearance.BottomFont.Color := clGray;
    pPlanner.GroupsAppearance.BottomFont.Height := -11;
    pPlanner.GroupsAppearance.BottomFont.Name := 'Segoe UI';
    pPlanner.GroupsAppearance.BottomFont.Style := [];
    pPlanner.GroupsAppearance.TopVerticalTextMode := pvtmNone;
    pPlanner.FullDaysAppearance.AutoItemHeight := 25.000000000000000000;
    pPlanner.FullDaysAppearance.TopSize := 25.000000000000000000;
    pPlanner.FullDaysAppearance.BottomSize := 25.000000000000000000;
    pPlanner.FullDaysAppearance.TopFont.Charset := DEFAULT_CHARSET;
    pPlanner.FullDaysAppearance.TopFont.Color := clWindowText;
    pPlanner.FullDaysAppearance.TopFont.Height := -11;
    pPlanner.FullDaysAppearance.TopFont.Name := 'Segoe UI';
    pPlanner.FullDaysAppearance.TopFont.Style := [];
    pPlanner.FullDaysAppearance.BottomFont.Charset := DEFAULT_CHARSET;
    pPlanner.FullDaysAppearance.BottomFont.Color := clWindowText;
    pPlanner.FullDaysAppearance.BottomFont.Height := -11;
    pPlanner.FullDaysAppearance.BottomFont.Name := 'Segoe UI';
    pPlanner.FullDaysAppearance.BottomFont.Style := [];
    pPlanner.Interaction.UpdateMode := pumDialog;
    pPlanner.Items.Clear;
    with pPlanner.Items.Add do
    begin
      Text := 'Test performance of the new feature.<br><i>And with remote connection.</i>';
      Title := 'QA';
      StartTime := 45217.354166666660000000;
      EndTime := 45217.458333333340000000;
      StrokeColor := clDarkgray;
      TitleStrokeColor := clDarkgray;
      SelectedColor := 15776936;
      SelectedStrokeColor := 15106394;
      SelectedTitleStrokeColor := 15106394;
      ActiveColor := 15776936;
      ActiveStrokeColor := 15106394;
      ActiveTitleStrokeColor := 15106394;
      FontColor := 8026746;
      TitleFontColor := 4539717;
      ActiveFontColor := 4539717;
      ActiveTitleFontColor := 4539717;
      MarkType := [imtTop];
      MarkColor := 15106394;
      MarkSizeTop := 8.000000000000000000;
      MarkRounding := 3;
      MarkCorners := [gcTopLeft,gcTopRight];
      Rounding := 3;
      RoundingCorners := [gcTopLeft,gcTopRight,gcBottomLeft,gcBottomRight];
    end;
    with pPlanner.Items.Add do
    begin
      Text := 'Write the developers guide and <a href="https://www.tmssoftware.com">FAQ</a>';
      Title := 'Documentation';
      StartTime := 45217.520833333340000000;
      EndTime := 45217.593750000000000000;
      Color := 16711679;
      StrokeColor := clDarkgray;
      TitleStrokeColor := clDarkgray;
      SelectedColor := 13824723;
      SelectedStrokeColor := 11070896;
      SelectedTitleStrokeColor := 11070896;
      ActiveColor := 13824723;
      ActiveStrokeColor := 11070896;
      ActiveTitleStrokeColor := 11070896;
      FontColor := 8026746;
      TitleFontColor := 4539717;
      ActiveFontColor := 4539717;
      ActiveTitleFontColor := 4539717;
      MarkType := [imtTop];
      MarkColor := 11070896;
      MarkSizeTop := 8.000000000000000000;
      MarkRounding := 3;
      MarkCorners := [gcTopLeft,gcTopRight];
      Rounding := 3;
      RoundingCorners := [gcTopLeft,gcTopRight,gcBottomLeft,gcBottomRight];
    end;
    with pPlanner.Items.Add do
    begin
      Text := 'Fix <u>high priority</u> issues documented by customer.';
      Title := 'Bugfix 376';
      StartTime := 45218.458333333340000000;
      EndTime := 45218.645833333340000000;
      Color := 16711679;
      StrokeColor := clDarkgray;
      TitleStrokeColor := clDarkgray;
      SelectedColor := 10984945;
      SelectedStrokeColor := 5456878;
      SelectedTitleStrokeColor := 5456878;
      ActiveColor := 10984945;
      ActiveStrokeColor := 5456878;
      ActiveTitleStrokeColor := 5456878;
      FontColor := 8026746;
      TitleFontColor := 4539717;
      ActiveFontColor := 4539717;
      ActiveTitleFontColor := 4539717;
      MarkType := [imtTop];
      MarkColor := 5456878;
      MarkSizeTop := 8.000000000000000000;
      MarkRounding := 3;
      MarkCorners := [gcTopLeft,gcTopRight];
      Rounding := 3;
      RoundingCorners := [gcTopLeft,gcTopRight,gcBottomLeft,gcBottomRight];
    end;
    with pPlanner.Items.Add do
    begin
      Text := 'Get in contact with the customer to let him know how far we are on developing the newly requested items.';
      Title := 'Customer Update';
      StartTime := 45219.354166666660000000;
      EndTime := 45219.458333333340000000;
      Color := 16711679;
      StrokeColor := clDarkgray;
      TitleStrokeColor := clDarkgray;
      SelectedColor := 16116138;
      SelectedStrokeColor := 15719007;
      SelectedTitleStrokeColor := 15719007;
      ActiveColor := 16116138;
      ActiveStrokeColor := 15719007;
      ActiveTitleStrokeColor := 15719007;
      FontColor := 8026746;
      TitleFontColor := 4539717;
      ActiveFontColor := 4539717;
      ActiveTitleFontColor := 4539717;
      MarkType := [imtTop];
      MarkColor := 15719007;
      MarkSizeTop := 8.000000000000000000;
      MarkRounding := 3;
      MarkCorners := [gcTopLeft,gcTopRight];
      Rounding := 3;
      RoundingCorners := [gcTopLeft,gcTopRight,gcBottomLeft,gcBottomRight];
    end;
    with pPlanner.Items.Add do
    begin
      Text := 'Issue when using non-alphanumeric characters.';
      Title := 'Bugfix 374';
      StartTime := 45219.520833333340000000;
      EndTime := 45219.666666666660000000;
      Color := 16711679;
      StrokeColor := clDarkgray;
      TitleStrokeColor := clDarkgray;
      SelectedColor := 10019314;
      SelectedStrokeColor := 3525360;
      SelectedTitleStrokeColor := 3525360;
      ActiveColor := 10019314;
      ActiveStrokeColor := 3525360;
      ActiveTitleStrokeColor := 3525360;
      FontColor := 8026746;
      TitleFontColor := 4539717;
      ActiveFontColor := 4539717;
      ActiveTitleFontColor := 4539717;
      MarkType := [imtTop];
      MarkColor := 3525360;
      MarkSizeTop := 8.000000000000000000;
      MarkRounding := 3;
      MarkCorners := [gcTopLeft,gcTopRight];
      Rounding := 3;
      RoundingCorners := [gcTopLeft,gcTopRight,gcBottomLeft,gcBottomRight];
    end;
    pPlanner.Mode := pmDayPeriod;
    pPlanner.ModeSettings.StartTime := 45198.651018518520000000;
    pPlanner.ModeSettings.EndTime := 45203.651018518520000000;
    pPlanner.OrientationMode := pomHorizontal;
    pPlanner.Positions.Count := 5;
    pPlanner.Positions.Format := 'dd/MM/yyyy';
    pPlanner.PositionsAppearance.Size := 100.000000000000000000;
    pPlanner.PositionsAppearance.Stretch := False;
    pPlanner.PositionsAppearance.TopSize := 120.000000000000000000;
    pPlanner.PositionsAppearance.BottomSize := 20.000000000000000000;
    pPlanner.PositionsAppearance.TopFont.Charset := DEFAULT_CHARSET;
    pPlanner.PositionsAppearance.TopFont.Color := 4539717;
    pPlanner.PositionsAppearance.TopFont.Height := -12;
    pPlanner.PositionsAppearance.TopFont.Name := 'Segoe UI';
    pPlanner.PositionsAppearance.TopFont.Style := [];
    pPlanner.PositionsAppearance.BottomFont.Charset := DEFAULT_CHARSET;
    pPlanner.PositionsAppearance.BottomFont.Color := 4539717;
    pPlanner.PositionsAppearance.BottomFont.Height := -13;
    pPlanner.PositionsAppearance.BottomFont.Name := 'Segoe UI';
    pPlanner.PositionsAppearance.BottomFont.Style := [fsBold];
    pPlanner.PositionsAppearance.TopHorizontalTextAlign := gtaLeading;
    pPlanner.PositionsAppearance.TopVerticalTextMode := pvtmNone;
    pPlanner.PositionsAppearance.BottomVerticalTextMode := pvtmNone;
    pPlanner.PositionsAppearance.TopLeftNavigationButtonSize := 18.000000000000000000;
    pPlanner.PositionsAppearance.TopRightNavigationButtonSize := 18.000000000000000000;
    pPlanner.PositionsAppearance.BottomLeftNavigationButtonSize := 18.000000000000000000;
    pPlanner.PositionsAppearance.BottomRightNavigationButtonSize := 18.000000000000000000;
    pPlanner.PositionsAppearance.FillEmptySpaces := False;
    pPlanner.Resources.Clear;
    with pPlanner.Resources.Add do
    begin
      Name := 'Resource0';
      Text := 'David';
    end;
    with pPlanner.Resources.Add do
    begin
      Name := 'Resource1';
      Text := 'Marie';
    end;
    with pPlanner.Resources.Add do
    begin
      Name := 'Resource2';
      Text := 'Carol';
    end;
    with pPlanner.Resources.Add do
    begin
      Name := 'Resource3';
      Text := 'Resource 3';
    end;
    with pPlanner.Resources.Add do
    begin
      Name := 'Resource4';
      Text := 'Resource 4';
    end;
    with pPlanner.Resources.Add do
    begin
      Name := 'Resource5';
      Text := 'Resource 5';
    end;
    pPlanner.SelectionAppearance.Stroke.Color := 15702829;
    pPlanner.SelectionAppearance.Stroke.Width := 2.000000000000000000;
    pPlanner.StretchScrollBars := True;
    pPlanner.Stroke.Color := clDarkgray;
    pPlanner.TimeLine.DisplayUnit := 1;
    pPlanner.TimeLine.DisplayUnitType := pduDay;
    pPlanner.TimeLine.ActiveStart := 17;
    pPlanner.TimeLine.ActiveEnd := 34;
    pPlanner.TimeLine.DisplayOffsetType := pduDay;
    pPlanner.TimeLine.DisplayUnitSize := 25.000000000000000000;
    pPlanner.TimeLine.ViewStart := 45198.000000000000000000;
    pPlanner.TimeLine.CurrentTimePosition := pctpOverItems;
    pPlanner.TimeLineAppearance.Stretch := True;
    pPlanner.TimeLineAppearance.LeftSize := 75.000000000000000000;
    pPlanner.TimeLineAppearance.RightSize := 250.000000000000000000;
    pPlanner.TimeLineAppearance.LeftFont.Charset := DEFAULT_CHARSET;
    pPlanner.TimeLineAppearance.LeftFont.Color := 4539717;
    pPlanner.TimeLineAppearance.LeftFont.Height := -12;
    pPlanner.TimeLineAppearance.LeftFont.Name := 'Segoe UI';
    pPlanner.TimeLineAppearance.LeftFont.Style := [fsBold];
    pPlanner.TimeLineAppearance.RightFont.Charset := DEFAULT_CHARSET;
    pPlanner.TimeLineAppearance.RightFont.Color := 4539717;
    pPlanner.TimeLineAppearance.RightFont.Height := -19;
    pPlanner.TimeLineAppearance.RightFont.Name := 'Segoe UI';
    pPlanner.TimeLineAppearance.RightFont.Style := [];
    pPlanner.TimeLineAppearance.LeftSubUnitFontSize := 9.000000000000000000;
    pPlanner.TimeLineAppearance.RightSubUnitFontSize := 9.000000000000000000;
    pPlanner.TimeLineAppearance.CurrentTimeColor := 15702829;
    pPlanner.TimeLineAppearance.LeftHorizontalTextAlign := gtaCenter;
    pPlanner.TimeLineAppearance.LeftVerticalTextAlign := gtaCenter;
    pPlanner.TimeLineAppearance.RightHorizontalTextAlign := gtaCenter;
    pPlanner.TimeLineAppearance.RightVerticalTextAlign := gtaCenter;
    pPlanner.TimeLineAppearance.LeftSubVerticalTextAlign := gtaCenter;
    pPlanner.TimeLineAppearance.RightSubHorizontalTextAlign := gtaCenter;
    pPlanner.TimeLineAppearance.RightSubVerticalTextAlign := gtaCenter;
    pPlanner.TimeLineAppearance.RightVerticalTextMode := pvtmAuto;
    pPlanner.TimeLineAppearance.RightSubVerticalTextMode := pvtmAuto;
    pPlanner.ItemsAppearance.Gap := 10.000000000000000000;
    pPlanner.ItemsAppearance.MoveAreaSize := 4.000000000000000000;
    pPlanner.ItemsAppearance.SizeAreaSize := 4.000000000000000000;
    pPlanner.ItemsAppearance.DeleteAreaSize := 16.000000000000000000;
    pPlanner.ItemsAppearance.DeleteHandlerBitmap.LoadFromFile('planning.enquiry.TMSFNCPageControl1Page0.pPlanner.ItemsAppearance.DeleteHandlerBitmap.png');
    pPlanner.ItemsAppearance.SizeHandlerHeight := 30.000000000000000000;
    pPlanner.ItemsAppearance.SizeHandlerWidth := 50.000000000000000000;
    pPlanner.ItemsAppearance.DeleteHandlerHeight := 30.000000000000000000;
    pPlanner.ItemsAppearance.DeleteHandlerWidth := 30.000000000000000000;
    pPlanner.ItemsAppearance.SizeHandlerLeftBitmap.LoadFromFile('planning.enquiry.TMSFNCPageControl1Page0.pPlanner.ItemsAppearance.SizeHandlerLeftBitmap.png');
    pPlanner.ItemsAppearance.SizeHandlerRightBitmap.LoadFromFile('planning.enquiry.TMSFNCPageControl1Page0.pPlanner.ItemsAppearance.SizeHandlerRightBitmap.png');
    pPlanner.ItemsAppearance.SizeHandlerUpBitmap.LoadFromFile('planning.enquiry.TMSFNCPageControl1Page0.pPlanner.ItemsAppearance.SizeHandlerUpBitmap.png');
    pPlanner.ItemsAppearance.SizeHandlerDownBitmap.LoadFromFile('planning.enquiry.TMSFNCPageControl1Page0.pPlanner.ItemsAppearance.SizeHandlerDownBitmap.png');
    pPlanner.ItemsAppearance.LinkStroke.Width := 2.000000000000000000;
    pPlanner.ItemsAppearance.LinkArrowSize := 7.000000000000000000;
    pPlanner.ItemsAppearance.TitleStroke.Color := -1;
    pPlanner.ItemsAppearance.TitleFont.Charset := DEFAULT_CHARSET;
    pPlanner.ItemsAppearance.TitleFont.Color := clWindowText;
    pPlanner.ItemsAppearance.TitleFont.Height := -12;
    pPlanner.ItemsAppearance.TitleFont.Name := 'Segoe UI';
    pPlanner.ItemsAppearance.TitleFont.Style := [fsBold];
    pPlanner.ItemsAppearance.Fill.TextureMode := gtmFit;
    pPlanner.ItemsAppearance.Stroke.Kind := gskSolid;
    pPlanner.ItemsAppearance.Font.Charset := DEFAULT_CHARSET;
    pPlanner.ItemsAppearance.Font.Color := clWindowText;
    pPlanner.ItemsAppearance.Font.Height := -11;
    pPlanner.ItemsAppearance.Font.Name := 'Segoe UI';
    pPlanner.ItemsAppearance.Font.Style := [];
    pPlanner.ItemsAppearance.SelectedTitleFont.Charset := DEFAULT_CHARSET;
    pPlanner.ItemsAppearance.SelectedTitleFont.Color := clWindowText;
    pPlanner.ItemsAppearance.SelectedTitleFont.Height := -12;
    pPlanner.ItemsAppearance.SelectedTitleFont.Name := 'Segoe UI';
    pPlanner.ItemsAppearance.SelectedTitleFont.Style := [fsBold];
    pPlanner.ItemsAppearance.ActiveTitleStroke.Color := -1;
    pPlanner.ItemsAppearance.ActiveTitleFont.Charset := DEFAULT_CHARSET;
    pPlanner.ItemsAppearance.ActiveTitleFont.Color := clWindowText;
    pPlanner.ItemsAppearance.ActiveTitleFont.Height := -12;
    pPlanner.ItemsAppearance.ActiveTitleFont.Name := 'Segoe UI';
    pPlanner.ItemsAppearance.ActiveTitleFont.Style := [fsBold];
    pPlanner.ItemsAppearance.SelectedFont.Charset := DEFAULT_CHARSET;
    pPlanner.ItemsAppearance.SelectedFont.Color := clWindowText;
    pPlanner.ItemsAppearance.SelectedFont.Height := -11;
    pPlanner.ItemsAppearance.SelectedFont.Name := 'Segoe UI';
    pPlanner.ItemsAppearance.SelectedFont.Style := [];
    pPlanner.ItemsAppearance.ActiveStroke.Kind := gskSolid;
    pPlanner.ItemsAppearance.ActiveFont.Charset := DEFAULT_CHARSET;
    pPlanner.ItemsAppearance.ActiveFont.Color := clWindowText;
    pPlanner.ItemsAppearance.ActiveFont.Height := -11;
    pPlanner.ItemsAppearance.ActiveFont.Name := 'Segoe UI';
    pPlanner.ItemsAppearance.ActiveFont.Style := [];
    pPlanner.ItemsAppearance.DisabledTitleFont.Charset := DEFAULT_CHARSET;
    pPlanner.ItemsAppearance.DisabledTitleFont.Color := clWindowText;
    pPlanner.ItemsAppearance.DisabledTitleFont.Height := -12;
    pPlanner.ItemsAppearance.DisabledTitleFont.Name := 'Segoe UI';
    pPlanner.ItemsAppearance.DisabledTitleFont.Style := [fsBold];
    pPlanner.ItemsAppearance.DisabledFont.Charset := DEFAULT_CHARSET;
    pPlanner.ItemsAppearance.DisabledFont.Color := clWindowText;
    pPlanner.ItemsAppearance.DisabledFont.Height := -11;
    pPlanner.ItemsAppearance.DisabledFont.Name := 'Segoe UI';
    pPlanner.ItemsAppearance.DisabledFont.Style := [];
    SetEvent(pPlanner, Self, 'OnAfterDrawItem', 'pPlannerAfterDrawItem');
    SetEvent(pPlanner, Self, 'OnAfterNavigateToDateTime', 'pPlannerAfterNavigateToDateTime');
    pdaPlanner.SetParentComponent(pPlanner);
    pdaPlanner.Name := 'pdaPlanner';
    pdaPlanner.Left := 408;
    pdaPlanner.Top := 120;
    pdaPlanner.Width := 26;
    pdaPlanner.Height := 26;
    pdaPlanner.Visible := True;
    pdaPlanner.Item.DataSource := dsPlanning;
    pdaPlanner.Item.Title := 'SystemType';
    pdaPlanner.Item.Text := 'ContractName';
    pdaPlanner.Item.StartTime := 'LoadingDate';
    pdaPlanner.Item.EndTime := 'OffLoadingDate';
    pdaPlanner.Item.Resource := 'RegSource';
    pdaPlanner.Item.DBKey := 'No';
    pdaPlanner.Item.AutoIncrementDBKey := False;
    wpLoadsButtons.SetParentComponent(TMSFNCPageControl1Page0);
    wpLoadsButtons.Name := 'wpLoadsButtons';
    wpLoadsButtons.Left := 0;
    wpLoadsButtons.Top := 0;
    wpLoadsButtons.Width := 1700;
    wpLoadsButtons.Height := 41;
    wpLoadsButtons.ElementClassName := 'card';
    wpLoadsButtons.Align := alTop;
    wpLoadsButtons.ChildOrder := 1;
    wpLoadsButtons.ElementBodyClassName := 'card-body';
    wpLoadsButtons.ElementFont := efCSS;
    wpLoadsButtons.TabOrder := 1;
    WebSpeedButton1.SetParentComponent(wpLoadsButtons);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 10;
    WebSpeedButton1.Top := 10;
    WebSpeedButton1.Width := 33;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.ElementClassName := 'btn btn-light';
    WebSpeedButton1.ElementFont := efCSS;
    WebSpeedButton1.HeightStyle := ssAuto;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(wpLoadsButtons);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 175;
    WebSpeedButton2.Top := 10;
    WebSpeedButton2.Width := 33;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Caption := '>';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.ElementClassName := 'btn btn-light';
    WebSpeedButton2.ElementFont := efCSS;
    WebSpeedButton2.HeightStyle := ssAuto;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    wpLoadsAdd.SetParentComponent(TMSFNCPageControl1Page0);
    wpLoadsAdd.Name := 'wpLoadsAdd';
    wpLoadsAdd.Left := 1183;
    wpLoadsAdd.Top := 41;
    wpLoadsAdd.Width := 517;
    wpLoadsAdd.Height := 538;
    wpLoadsAdd.ElementClassName := 'card';
    wpLoadsAdd.Align := alRight;
    wpLoadsAdd.ChildOrder := 2;
    wpLoadsAdd.ElementBodyClassName := 'card-body';
    wpLoadsAdd.ElementFont := efCSS;
    wpLoadsAdd.TabOrder := 2;
    WebWaitMessage1.SetParentComponent(wpLoadsAdd);
    WebWaitMessage1.Name := 'WebWaitMessage1';
    WebWaitMessage1.Left := 48;
    WebWaitMessage1.Top := 192;
    WebWaitMessage1.Width := 24;
    WebWaitMessage1.Height := 24;
    WebWaitMessage1.Opacity := 0.200000000000000000;
    WebWaitMessage1.Picture.LoadFromFile('planning.enquiry.wpLoadsAdd.WebWaitMessage1.Picture.gif');
    TMSFNCPageControl1Page3.SetParentComponent(TMSFNCPageControl1);
    TMSFNCPageControl1Page3.Name := 'TMSFNCPageControl1Page3';
    TMSFNCPageControl1Page3.AlignWithMargins := True;
    TMSFNCPageControl1Page3.Left := 0;
    TMSFNCPageControl1Page3.Top := 29;
    TMSFNCPageControl1Page3.Width := 1700;
    TMSFNCPageControl1Page3.Height := 579;
    TMSFNCPageControl1Page3.Margins.Left := 0;
    TMSFNCPageControl1Page3.Margins.Top := 29;
    TMSFNCPageControl1Page3.Margins.Right := 0;
    TMSFNCPageControl1Page3.Margins.Bottom := 0;
    TMSFNCPageControl1Page3.AdaptToStyle := True;
    TMSFNCPageControl1Page3.Align := alClient;
    TMSFNCPageControl1Page3.ParentDoubleBuffered := False;
    TMSFNCPageControl1Page3.Color := clSilver;
    TMSFNCPageControl1Page3.DoubleBuffered := True;
    TMSFNCPageControl1Page3.TabStop := False;
    TMSFNCPageControl1Page3.TabOrder := 3;
    TMSFNCPageControl1Page3.Stroke.Color := 15987699;
    TMSFNCPageControl1Page3.PageIndex := 0;
    TMSFNCPageControl1Page3.IsActive := True;
    gDashBoard.SetParentComponent(TMSFNCPageControl1Page3);
    gDashBoard.Name := 'gDashBoard';
    gDashBoard.Left := 0;
    gDashBoard.Top := 84;
    gDashBoard.Width := 1700;
    gDashBoard.Height := 409;
    gDashBoard.AdaptToStyle := True;
    gDashBoard.Align := alClient;
    gDashBoard.ParentDoubleBuffered := False;
    gDashBoard.DoubleBuffered := True;
    gDashBoard.TabOrder := 0;
    gDashBoard.DefaultRowHeight := 40.000000000000000000;
    gDashBoard.FixedColumns := 0;
    gDashBoard.ColumnCount := 29;
    gDashBoard.RowCount := 1;
    SetEvent(gDashBoard, Self, 'OnSortFormat', 'gDashBoardSortFormat');
    gDashBoard.Options.Bands.Enabled := True;
    gDashBoard.Options.Cell.DisplayHTMLFormatting := True;
    gDashBoard.Options.Editing.CalcFormat := '%g';
    gDashBoard.Options.Grouping.CalcFormat := '%g';
    gDashBoard.Options.Grouping.GroupCountFormat := '(%d)';
    gDashBoard.Options.IO.XMLEncoding := 'ISO-8859-1';
    gDashBoard.Options.Mouse.ClickMargin := 0;
    gDashBoard.Options.Mouse.ColumnSizeMargin := 6;
    gDashBoard.Options.Mouse.RowSizeMargin := 6;
    gDashBoard.Options.Sorting.Mode := gsmNormal;
    gDashBoard.Adapter := gdaDashBoard;
    gDashBoard.Columns.Clear;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 250.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 120.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 120.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaCenter;
      ID := '';
      ReadOnly := True;
      Width := 75.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 100.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 100.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 75.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 65.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 0.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      Width := 0.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 75.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaCenter;
      ID := '';
      ReadOnly := True;
      Width := 85.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaCenter;
      ID := '';
      ReadOnly := True;
      Width := 85.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 150.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 150.000000000000000000;
      WordWrap := True;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      Editor := etCustom;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 90.000000000000000000;
    end;
    with gDashBoard.Columns.Add do
    begin
      BorderWidth := 1;
      Editor := etCustom;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 90.000000000000000000;
    end;
    gDashBoard.DefaultFont.Charset := DEFAULT_CHARSET;
    gDashBoard.DefaultFont.Color := clBlack;
    gDashBoard.DefaultFont.Height := -11;
    gDashBoard.DefaultFont.Name := 'Segoe UI';
    gDashBoard.DefaultFont.Style := [];
    gDashBoard.Stroke.Color := 15987699;
    gDashBoard.TopRow := 1;
    gDashBoard.Appearance.FixedLayout.Fill.Kind := gfkGradient;
    gDashBoard.Appearance.FixedLayout.Fill.Color := 16382457;
    gDashBoard.Appearance.FixedLayout.Fill.ColorTo := 16382457;
    gDashBoard.Appearance.FixedLayout.Stroke.Color := 15987699;
    gDashBoard.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gDashBoard.Appearance.FixedLayout.Font.Color := clBlack;
    gDashBoard.Appearance.FixedLayout.Font.Height := -13;
    gDashBoard.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gDashBoard.Appearance.FixedLayout.Font.Style := [fsBold];
    gDashBoard.Appearance.FixedLayout.WordWrapping := True;
    gDashBoard.Appearance.NormalLayout.Fill.Color := 16578806;
    gDashBoard.Appearance.NormalLayout.Stroke.Color := 15987699;
    gDashBoard.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gDashBoard.Appearance.NormalLayout.Font.Color := clBlack;
    gDashBoard.Appearance.NormalLayout.Font.Height := -11;
    gDashBoard.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gDashBoard.Appearance.NormalLayout.Font.Style := [];
    gDashBoard.Appearance.GroupLayout.Fill.Kind := gfkGradient;
    gDashBoard.Appearance.GroupLayout.Fill.Color := 15385233;
    gDashBoard.Appearance.GroupLayout.Fill.ColorTo := 15385233;
    gDashBoard.Appearance.GroupLayout.Stroke.Color := 15987699;
    gDashBoard.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gDashBoard.Appearance.GroupLayout.Font.Color := clBlack;
    gDashBoard.Appearance.GroupLayout.Font.Height := -11;
    gDashBoard.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gDashBoard.Appearance.GroupLayout.Font.Style := [];
    gDashBoard.Appearance.SummaryLayout.Fill.Kind := gfkGradient;
    gDashBoard.Appearance.SummaryLayout.Fill.Color := 15385233;
    gDashBoard.Appearance.SummaryLayout.Fill.ColorTo := 15385233;
    gDashBoard.Appearance.SummaryLayout.Stroke.Color := 15987699;
    gDashBoard.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gDashBoard.Appearance.SummaryLayout.Font.Color := clBlack;
    gDashBoard.Appearance.SummaryLayout.Font.Height := -11;
    gDashBoard.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gDashBoard.Appearance.SummaryLayout.Font.Style := [];
    gDashBoard.Appearance.SelectedLayout.Fill.Kind := gfkGradient;
    gDashBoard.Appearance.SelectedLayout.Fill.Color := 15385233;
    gDashBoard.Appearance.SelectedLayout.Fill.ColorTo := 15385233;
    gDashBoard.Appearance.SelectedLayout.Stroke.Color := 15987699;
    gDashBoard.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gDashBoard.Appearance.SelectedLayout.Font.Color := clBlack;
    gDashBoard.Appearance.SelectedLayout.Font.Height := -11;
    gDashBoard.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gDashBoard.Appearance.SelectedLayout.Font.Style := [];
    gDashBoard.Appearance.FocusedLayout.Fill.Kind := gfkGradient;
    gDashBoard.Appearance.FocusedLayout.Fill.Color := 15385233;
    gDashBoard.Appearance.FocusedLayout.Fill.ColorTo := 15385233;
    gDashBoard.Appearance.FocusedLayout.Stroke.Color := 15987699;
    gDashBoard.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gDashBoard.Appearance.FocusedLayout.Font.Color := clBlack;
    gDashBoard.Appearance.FocusedLayout.Font.Height := -11;
    gDashBoard.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gDashBoard.Appearance.FocusedLayout.Font.Style := [];
    gDashBoard.Appearance.FixedSelectedLayout.Fill.Kind := gfkGradient;
    gDashBoard.Appearance.FixedSelectedLayout.Fill.Color := 15385233;
    gDashBoard.Appearance.FixedSelectedLayout.Fill.ColorTo := 15385233;
    gDashBoard.Appearance.FixedSelectedLayout.Stroke.Color := 15987699;
    gDashBoard.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gDashBoard.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gDashBoard.Appearance.FixedSelectedLayout.Font.Height := -11;
    gDashBoard.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gDashBoard.Appearance.FixedSelectedLayout.Font.Style := [];
    gDashBoard.Appearance.BandLayout.Fill.Color := 16711679;
    gDashBoard.Appearance.BandLayout.Stroke.Color := 15987699;
    gDashBoard.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gDashBoard.Appearance.BandLayout.Font.Color := 8026746;
    gDashBoard.Appearance.BandLayout.Font.Height := -11;
    gDashBoard.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gDashBoard.Appearance.BandLayout.Font.Style := [];
    gDashBoard.Appearance.ProgressLayout.Color := 15385233;
    gDashBoard.Appearance.ProgressLayout.Format := '%.0f%%';
    gDashBoard.LeftCol := 3;
    gDashBoard.ScrollMode := scmItemScrolling;
    gDashBoard.FreezeColumns := 3;
    gDashBoard.DesignTimeSampleData := True;
    SetEvent(gDashBoard, Self, 'OnGetCellLayout', 'gDashBoardGetCellLayout');
    SetEvent(gDashBoard, Self, 'OnCellButtonClick', 'gDashBoardCellButtonClick');
    WebMessageDlg1.SetParentComponent(gDashBoard);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 584;
    WebMessageDlg1.Top := 152;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    sbBottom.SetParentComponent(TMSFNCPageControl1Page3);
    sbBottom.Name := 'sbBottom';
    sbBottom.AlignWithMargins := True;
    sbBottom.Left := 3;
    sbBottom.Top := 496;
    sbBottom.Width := 1694;
    sbBottom.Height := 80;
    sbBottom.Align := alBottom;
    sbBottom.AutoScroll := True;
    sbBottom.BorderStyle := bsSingle;
    sbBottom.ChildOrder := 3;
    sbBottom.Color := clSilver;
    WebLabel6.SetParentComponent(sbBottom);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 10;
    WebLabel6.Top := 30;
    WebLabel6.Width := 42;
    WebLabel6.Height := 16;
    WebLabel6.Caption := 'Total : ';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -13;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel11.SetParentComponent(sbBottom);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 559;
    WebLabel11.Top := 8;
    WebLabel11.Width := 102;
    WebLabel11.Height := 16;
    WebLabel11.Alignment := taRightJustify;
    WebLabel11.Caption := 'Fuel Consumption';
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clWindowText;
    WebLabel11.Font.Height := -13;
    WebLabel11.Font.Name := 'Tahoma';
    WebLabel11.Font.Style := [];
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.ParentFont := False;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(sbBottom);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 462;
    WebLabel10.Top := 8;
    WebLabel10.Width := 72;
    WebLabel10.Height := 16;
    WebLabel10.Alignment := taRightJustify;
    WebLabel10.Caption := 'Day Average';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := -13;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [];
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.ParentFont := False;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(sbBottom);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 364;
    WebLabel9.Top := 8;
    WebLabel9.Width := 43;
    WebLabel9.Height := 16;
    WebLabel9.Alignment := taRightJustify;
    WebLabel9.Caption := 'Surplus';
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := -13;
    WebLabel9.Font.Name := 'Tahoma';
    WebLabel9.Font.Style := [];
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.ParentFont := False;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(sbBottom);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 231;
    WebLabel8.Top := 8;
    WebLabel8.Width := 49;
    WebLabel8.Height := 16;
    WebLabel8.Alignment := taRightJustify;
    WebLabel8.Caption := 'Revenue';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -13;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [];
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(sbBottom);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 120;
    WebLabel7.Top := 8;
    WebLabel7.Width := 33;
    WebLabel7.Height := 16;
    WebLabel7.Alignment := taRightJustify;
    WebLabel7.Caption := 'Count';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -13;
    WebLabel7.Font.Name := 'Tahoma';
    WebLabel7.Font.Style := [];
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    weCount.SetParentComponent(sbBottom);
    weCount.Name := 'weCount';
    weCount.Left := 101;
    weCount.Top := 27;
    weCount.Width := 52;
    weCount.Height := 22;
    weCount.Alignment := taRightJustify;
    weCount.ChildOrder := 1;
    weCount.Font.Charset := DEFAULT_CHARSET;
    weCount.Font.Color := clWindowText;
    weCount.Font.Height := -13;
    weCount.Font.Name := 'Tahoma';
    weCount.Font.Style := [];
    weCount.HeightPercent := 100.000000000000000000;
    weCount.ParentFont := False;
    weCount.ReadOnly := True;
    weCount.WidthPercent := 100.000000000000000000;
    weTotalRev.SetParentComponent(sbBottom);
    weTotalRev.Name := 'weTotalRev';
    weTotalRev.Left := 159;
    weTotalRev.Top := 27;
    weTotalRev.Width := 121;
    weTotalRev.Height := 22;
    weTotalRev.Alignment := taRightJustify;
    weTotalRev.ChildOrder := 1;
    weTotalRev.Font.Charset := DEFAULT_CHARSET;
    weTotalRev.Font.Color := clWindowText;
    weTotalRev.Font.Height := -13;
    weTotalRev.Font.Name := 'Tahoma';
    weTotalRev.Font.Style := [];
    weTotalRev.HeightPercent := 100.000000000000000000;
    weTotalRev.ParentFont := False;
    weTotalRev.ReadOnly := True;
    weTotalRev.WidthPercent := 100.000000000000000000;
    weTotalSurplus.SetParentComponent(sbBottom);
    weTotalSurplus.Name := 'weTotalSurplus';
    weTotalSurplus.Left := 286;
    weTotalSurplus.Top := 27;
    weTotalSurplus.Width := 121;
    weTotalSurplus.Height := 22;
    weTotalSurplus.Alignment := taRightJustify;
    weTotalSurplus.ChildOrder := 1;
    weTotalSurplus.Font.Charset := DEFAULT_CHARSET;
    weTotalSurplus.Font.Color := clWindowText;
    weTotalSurplus.Font.Height := -13;
    weTotalSurplus.Font.Name := 'Tahoma';
    weTotalSurplus.Font.Style := [];
    weTotalSurplus.HeightPercent := 100.000000000000000000;
    weTotalSurplus.ParentFont := False;
    weTotalSurplus.ReadOnly := True;
    weTotalSurplus.WidthPercent := 100.000000000000000000;
    weAvgDay.SetParentComponent(sbBottom);
    weAvgDay.Name := 'weAvgDay';
    weAvgDay.Left := 413;
    weAvgDay.Top := 27;
    weAvgDay.Width := 121;
    weAvgDay.Height := 22;
    weAvgDay.Alignment := taRightJustify;
    weAvgDay.ChildOrder := 1;
    weAvgDay.Font.Charset := DEFAULT_CHARSET;
    weAvgDay.Font.Color := clWindowText;
    weAvgDay.Font.Height := -13;
    weAvgDay.Font.Name := 'Tahoma';
    weAvgDay.Font.Style := [];
    weAvgDay.HeightPercent := 100.000000000000000000;
    weAvgDay.ParentFont := False;
    weAvgDay.ReadOnly := True;
    weAvgDay.WidthPercent := 100.000000000000000000;
    weAvgFuel.SetParentComponent(sbBottom);
    weAvgFuel.Name := 'weAvgFuel';
    weAvgFuel.Left := 540;
    weAvgFuel.Top := 27;
    weAvgFuel.Width := 121;
    weAvgFuel.Height := 22;
    weAvgFuel.Alignment := taRightJustify;
    weAvgFuel.ChildOrder := 1;
    weAvgFuel.Font.Charset := DEFAULT_CHARSET;
    weAvgFuel.Font.Color := clWindowText;
    weAvgFuel.Font.Height := -13;
    weAvgFuel.Font.Name := 'Tahoma';
    weAvgFuel.Font.Style := [];
    weAvgFuel.HeightPercent := 100.000000000000000000;
    weAvgFuel.ParentFont := False;
    weAvgFuel.ReadOnly := True;
    weAvgFuel.WidthPercent := 100.000000000000000000;
    sbDashBoard.SetParentComponent(TMSFNCPageControl1Page3);
    sbDashBoard.Name := 'sbDashBoard';
    sbDashBoard.AlignWithMargins := True;
    sbDashBoard.Left := 3;
    sbDashBoard.Top := 3;
    sbDashBoard.Width := 1694;
    sbDashBoard.Height := 78;
    sbDashBoard.Align := alTop;
    sbDashBoard.AutoScroll := True;
    sbDashBoard.BorderStyle := bsSingle;
    sbDashBoard.ChildOrder := 3;
    sbDashBoard.Color := clSilver;
    WebLabel2.SetParentComponent(sbDashBoard);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 10;
    WebLabel2.Top := 8;
    WebLabel2.Width := 66;
    WebLabel2.Height := 16;
    WebLabel2.Caption := 'Company : ';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -13;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightStyle := ssAuto;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(sbDashBoard);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 259;
    WebLabel3.Top := 8;
    WebLabel3.Width := 47;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'Group : ';
    WebLabel3.ElementFont := efCSS;
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -13;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(sbDashBoard);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 444;
    WebLabel4.Top := 8;
    WebLabel4.Width := 54;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'Reg No : ';
    WebLabel4.ElementFont := efCSS;
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -13;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightStyle := ssAuto;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(sbDashBoard);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 610;
    WebLabel12.Top := 8;
    WebLabel12.Width := 69;
    WebLabel12.Height := 16;
    WebLabel12.Caption := 'Controller : ';
    WebLabel12.ElementFont := efCSS;
    WebLabel12.Font.Charset := DEFAULT_CHARSET;
    WebLabel12.Font.Color := clWindowText;
    WebLabel12.Font.Height := -13;
    WebLabel12.Font.Name := 'Tahoma';
    WebLabel12.Font.Style := [];
    WebLabel12.HeightStyle := ssAuto;
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.ParentFont := False;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(sbDashBoard);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 828;
    WebLabel5.Top := 8;
    WebLabel5.Width := 39;
    WebLabel5.Height := 16;
    WebLabel5.Caption := 'Date : ';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -13;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    lCompany.SetParentComponent(sbDashBoard);
    lCompany.Name := 'lCompany';
    lCompany.Left := 10;
    lCompany.Top := 27;
    lCompany.Width := 212;
    lCompany.Height := 22;
    lCompany.ChildOrder := 3;
    lCompany.Font.Charset := DEFAULT_CHARSET;
    lCompany.Font.Color := clWindowText;
    lCompany.Font.Height := -13;
    lCompany.Font.Name := 'Tahoma';
    lCompany.Font.Style := [];
    lCompany.HeightStyle := ssAuto;
    lCompany.HeightPercent := 100.000000000000000000;
    lCompany.ParentFont := False;
    lCompany.ReadOnly := True;
    lCompany.WidthPercent := 100.000000000000000000;
    SetEvent(lCompany, Self, 'OnKeyDown', 'lCompanyKeyDown');
    WebSpeedButton3.SetParentComponent(sbDashBoard);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 222;
    WebSpeedButton3.Top := 27;
    WebSpeedButton3.Width := 27;
    WebSpeedButton3.Height := 22;
    WebSpeedButton3.Caption := '...';
    WebSpeedButton3.Color := clSilver;
    WebSpeedButton3.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton3.Font.Color := clWindowText;
    WebSpeedButton3.Font.Height := -12;
    WebSpeedButton3.Font.Name := 'Tahoma';
    WebSpeedButton3.Font.Style := [fsBold];
    WebSpeedButton3.HeightStyle := ssAuto;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.ParentFont := False;
    WebSpeedButton3.TabOrder := 1;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    lGroup.SetParentComponent(sbDashBoard);
    lGroup.Name := 'lGroup';
    lGroup.Left := 259;
    lGroup.Top := 27;
    lGroup.Width := 152;
    lGroup.Height := 22;
    lGroup.ChildOrder := 4;
    lGroup.Font.Charset := DEFAULT_CHARSET;
    lGroup.Font.Color := clWindowText;
    lGroup.Font.Height := -13;
    lGroup.Font.Name := 'Tahoma';
    lGroup.Font.Style := [];
    lGroup.HeightStyle := ssAuto;
    lGroup.HeightPercent := 100.000000000000000000;
    lGroup.ParentFont := False;
    lGroup.ReadOnly := True;
    lGroup.WidthPercent := 100.000000000000000000;
    SetEvent(lGroup, Self, 'OnKeyDown', 'lGroupKeyDown');
    WebSpeedButton4.SetParentComponent(sbDashBoard);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 411;
    WebSpeedButton4.Top := 27;
    WebSpeedButton4.Width := 25;
    WebSpeedButton4.Height := 22;
    WebSpeedButton4.Caption := '...';
    WebSpeedButton4.Color := clSilver;
    WebSpeedButton4.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton4.Font.Color := clWindowText;
    WebSpeedButton4.Font.Height := -12;
    WebSpeedButton4.Font.Name := 'Tahoma';
    WebSpeedButton4.Font.Style := [fsBold];
    WebSpeedButton4.HeightStyle := ssAuto;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.ParentFont := False;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    lRegNo.SetParentComponent(sbDashBoard);
    lRegNo.Name := 'lRegNo';
    lRegNo.Left := 444;
    lRegNo.Top := 27;
    lRegNo.Width := 133;
    lRegNo.Height := 22;
    lRegNo.ChildOrder := 5;
    lRegNo.Font.Charset := DEFAULT_CHARSET;
    lRegNo.Font.Color := clWindowText;
    lRegNo.Font.Height := -13;
    lRegNo.Font.Name := 'Tahoma';
    lRegNo.Font.Style := [];
    lRegNo.HeightStyle := ssAuto;
    lRegNo.HeightPercent := 100.000000000000000000;
    lRegNo.ParentFont := False;
    lRegNo.ReadOnly := True;
    lRegNo.WidthPercent := 100.000000000000000000;
    SetEvent(lRegNo, Self, 'OnKeyDown', 'lRegNoKeyDown');
    WebSpeedButton5.SetParentComponent(sbDashBoard);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 577;
    WebSpeedButton5.Top := 27;
    WebSpeedButton5.Width := 25;
    WebSpeedButton5.Height := 22;
    WebSpeedButton5.Caption := '...';
    WebSpeedButton5.Color := clSilver;
    WebSpeedButton5.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton5.Font.Color := clWindowText;
    WebSpeedButton5.Font.Height := -12;
    WebSpeedButton5.Font.Name := 'Tahoma';
    WebSpeedButton5.Font.Style := [fsBold];
    WebSpeedButton5.HeightStyle := ssAuto;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.ParentFont := False;
    WebSpeedButton5.TabOrder := 5;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    lController.SetParentComponent(sbDashBoard);
    lController.Name := 'lController';
    lController.Left := 610;
    lController.Top := 27;
    lController.Width := 184;
    lController.Height := 22;
    lController.ChildOrder := 5;
    lController.Font.Charset := DEFAULT_CHARSET;
    lController.Font.Color := clWindowText;
    lController.Font.Height := -13;
    lController.Font.Name := 'Tahoma';
    lController.Font.Style := [];
    lController.HeightStyle := ssAuto;
    lController.HeightPercent := 100.000000000000000000;
    lController.ParentFont := False;
    lController.ReadOnly := True;
    lController.WidthPercent := 100.000000000000000000;
    SetEvent(lController, Self, 'OnKeyDown', 'lControllerKeyDown');
    WebSpeedButton6.SetParentComponent(sbDashBoard);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 794;
    WebSpeedButton6.Top := 27;
    WebSpeedButton6.Width := 25;
    WebSpeedButton6.Height := 22;
    WebSpeedButton6.Caption := '...';
    WebSpeedButton6.Color := clSilver;
    WebSpeedButton6.Font.Charset := DEFAULT_CHARSET;
    WebSpeedButton6.Font.Color := clWindowText;
    WebSpeedButton6.Font.Height := -12;
    WebSpeedButton6.Font.Name := 'Tahoma';
    WebSpeedButton6.Font.Style := [fsBold];
    WebSpeedButton6.HeightStyle := ssAuto;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.ParentFont := False;
    WebSpeedButton6.TabOrder := 7;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    dtPicker.SetParentComponent(sbDashBoard);
    dtPicker.Name := 'dtPicker';
    dtPicker.Left := 828;
    dtPicker.Top := 27;
    dtPicker.Width := 105;
    dtPicker.Height := 26;
    dtPicker.BorderStyle := bsSingle;
    dtPicker.ChildOrder := 11;
    dtPicker.Color := clWhite;
    dtPicker.Date := 45236.742469027780000000;
    dtPicker.Font.Charset := DEFAULT_CHARSET;
    dtPicker.Font.Color := clWindowText;
    dtPicker.Font.Height := -13;
    dtPicker.Font.Name := 'Tahoma';
    dtPicker.Font.Style := [];
    dtPicker.ParentFont := False;
    dtPicker.Role := '';
    dtPicker.Text := '';
    btnSearch.SetParentComponent(sbDashBoard);
    btnSearch.Name := 'btnSearch';
    btnSearch.Left := 942;
    btnSearch.Top := 27;
    btnSearch.Width := 108;
    btnSearch.Height := 24;
    btnSearch.Caption := 'Search';
    btnSearch.Color := clSilver;
    btnSearch.Font.Charset := DEFAULT_CHARSET;
    btnSearch.Font.Color := clWindowText;
    btnSearch.Font.Height := -12;
    btnSearch.Font.Name := 'Tahoma';
    btnSearch.Font.Style := [];
    btnSearch.HeightStyle := ssAuto;
    btnSearch.HeightPercent := 100.000000000000000000;
    btnSearch.ParentFont := False;
    btnSearch.TabOrder := 9;
    btnSearch.WidthPercent := 100.000000000000000000;
    SetEvent(btnSearch, Self, 'OnClick', 'btnSearchClick');
    wcPlanning.SetParentComponent(Self);
    wcPlanning.Name := 'wcPlanning';
    wcPlanning.Connection := dmData.dbConnect;
    wcPlanning.Left := 392;
    wcPlanning.Top := 169;
    qPlanning.SetParentComponent(Self);
    qPlanning.Name := 'qPlanning';
    qPlanning.AfterOpen := qPlanningAfterOpen;
    qPlanning.Connection := dmData.dbConnect;
    qPlanning.Left := 272;
    qPlanning.Top := 161;
    qPlanningNo.SetParentComponent(qPlanning);
    qPlanningNo.Name := 'qPlanningNo';
    qPlanningNo.FieldName := 'No';
    qPlanningRegSource.SetParentComponent(qPlanning);
    qPlanningRegSource.Name := 'qPlanningRegSource';
    qPlanningRegSource.FieldName := 'RegSource';
    qPlanningRegNo.SetParentComponent(qPlanning);
    qPlanningRegNo.Name := 'qPlanningRegNo';
    qPlanningRegNo.FieldName := 'RegNo';
    qPlanningContractNo.SetParentComponent(qPlanning);
    qPlanningContractNo.Name := 'qPlanningContractNo';
    qPlanningContractNo.FieldName := 'ContractNo';
    qPlanningContractName.SetParentComponent(qPlanning);
    qPlanningContractName.Name := 'qPlanningContractName';
    qPlanningContractName.FieldName := 'ContractName';
    qPlanningSubCode.SetParentComponent(qPlanning);
    qPlanningSubCode.Name := 'qPlanningSubCode';
    qPlanningSubCode.FieldName := 'SubCode';
    qPlanningSubName.SetParentComponent(qPlanning);
    qPlanningSubName.Name := 'qPlanningSubName';
    qPlanningSubName.FieldName := 'SubName';
    qPlanningCanceled.SetParentComponent(qPlanning);
    qPlanningCanceled.Name := 'qPlanningCanceled';
    qPlanningCanceled.FieldName := 'Canceled';
    qPlanningLoaded.SetParentComponent(qPlanning);
    qPlanningLoaded.Name := 'qPlanningLoaded';
    qPlanningLoaded.FieldName := 'Loaded';
    qPlanningOffLoaded.SetParentComponent(qPlanning);
    qPlanningOffLoaded.Name := 'qPlanningOffLoaded';
    qPlanningOffLoaded.FieldName := 'OffLoaded';
    qPlanningLoadconno.SetParentComponent(qPlanning);
    qPlanningLoadconno.Name := 'qPlanningLoadconno';
    qPlanningLoadconno.FieldName := 'Loadconno';
    qPlanningCInvoiceNo.SetParentComponent(qPlanning);
    qPlanningCInvoiceNo.Name := 'qPlanningCInvoiceNo';
    qPlanningCInvoiceNo.FieldName := 'CInvoiceNo';
    qPlanningCInvoiced.SetParentComponent(qPlanning);
    qPlanningCInvoiced.Name := 'qPlanningCInvoiced';
    qPlanningCInvoiced.FieldName := 'CInvoiced';
    qPlanningSInvoiceNo.SetParentComponent(qPlanning);
    qPlanningSInvoiceNo.Name := 'qPlanningSInvoiceNo';
    qPlanningSInvoiceNo.FieldName := 'SInvoiceNo';
    qPlanningSInvoiced.SetParentComponent(qPlanning);
    qPlanningSInvoiced.Name := 'qPlanningSInvoiced';
    qPlanningSInvoiced.FieldName := 'SInvoiced';
    qPlanningLoadStandTime.SetParentComponent(qPlanning);
    qPlanningLoadStandTime.Name := 'qPlanningLoadStandTime';
    qPlanningLoadStandTime.FieldName := 'LoadStandTime';
    qPlanningOffLoadStandTime.SetParentComponent(qPlanning);
    qPlanningOffLoadStandTime.Name := 'qPlanningOffLoadStandTime';
    qPlanningOffLoadStandTime.FieldName := 'OffLoadStandTime';
    qPlanningTrafelTime.SetParentComponent(qPlanning);
    qPlanningTrafelTime.Name := 'qPlanningTrafelTime';
    qPlanningTrafelTime.FieldName := 'TrafelTime';
    qPlanningTimeLeft.SetParentComponent(qPlanning);
    qPlanningTimeLeft.Name := 'qPlanningTimeLeft';
    qPlanningTimeLeft.FieldName := 'TimeLeft';
    qPlanningLoadingDate.SetParentComponent(qPlanning);
    qPlanningLoadingDate.Name := 'qPlanningLoadingDate';
    qPlanningLoadingDate.FieldName := 'LoadingDate';
    qPlanningOffLoadingDate.SetParentComponent(qPlanning);
    qPlanningOffLoadingDate.Name := 'qPlanningOffLoadingDate';
    qPlanningOffLoadingDate.FieldName := 'OffLoadingDate';
    qPlanningSystemType.SetParentComponent(qPlanning);
    qPlanningSystemType.Name := 'qPlanningSystemType';
    qPlanningSystemType.FieldName := 'SystemType';
    dsPlanning.SetParentComponent(Self);
    dsPlanning.Name := 'dsPlanning';
    dsPlanning.AutoEdit := False;
    dsPlanning.DataSet := qPlanning;
    dsPlanning.Left := 336;
    dsPlanning.Top := 169;
    qResources.SetParentComponent(Self);
    qResources.Name := 'qResources';
    qResources.AfterOpen := qResourcesAfterOpen;
    qResources.Connection := dmData.dbConnect;
    qResources.Left := 256;
    qResources.Top := 313;
    qResourcesNo.SetParentComponent(qResources);
    qResourcesNo.Name := 'qResourcesNo';
    qResourcesNo.FieldName := 'No';
    qResourcesRegNo.SetParentComponent(qResources);
    qResourcesRegNo.Name := 'qResourcesRegNo';
    qResourcesRegNo.FieldName := 'RegNo';
    dsResources.SetParentComponent(Self);
    dsResources.Name := 'dsResources';
    dsResources.AutoEdit := False;
    dsResources.DataSet := qResources;
    dsResources.Left := 336;
    dsResources.Top := 313;
    wcResources.SetParentComponent(Self);
    wcResources.Name := 'wcResources';
    wcResources.Connection := dmData.dbConnect;
    wcResources.Left := 496;
    wcResources.Top := 297;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Enabled := False;
    WebTimer1.Interval := 60000;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 704;
    WebTimer1.Top := 26;
    qDashBoard.SetParentComponent(Self);
    qDashBoard.Name := 'qDashBoard';
    qDashBoard.AfterOpen := qDashBoardAfterOpen;
    qDashBoard.Connection := dmData.dbConnect;
    qDashBoard.Left := 688;
    qDashBoard.Top := 209;
    IntegerField1.SetParentComponent(qDashBoard);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'No';
    StringField1.SetParentComponent(qDashBoard);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'RegNo';
    qDashBoardSubCode.SetParentComponent(qDashBoard);
    qDashBoardSubCode.Name := 'qDashBoardSubCode';
    qDashBoardSubCode.FieldName := 'SubCode';
    qDashBoardSubName.SetParentComponent(qDashBoard);
    qDashBoardSubName.Name := 'qDashBoardSubName';
    qDashBoardSubName.FieldName := 'SubName';
    qDashBoardLoadsNotStarted.SetParentComponent(qDashBoard);
    qDashBoardLoadsNotStarted.Name := 'qDashBoardLoadsNotStarted';
    qDashBoardLoadsNotStarted.FieldName := 'LoadsNotStarted';
    qDashBoardLoadsStarted.SetParentComponent(qDashBoard);
    qDashBoardLoadsStarted.Name := 'qDashBoardLoadsStarted';
    qDashBoardLoadsStarted.FieldName := 'LoadsStarted';
    qDashBoardKilos.SetParentComponent(qDashBoard);
    qDashBoardKilos.Name := 'qDashBoardKilos';
    qDashBoardKilos.FieldName := 'Kilos';
    qDashBoardKilos.DisplayFormat := '#,##0';
    qDashBoardLastKilosService.SetParentComponent(qDashBoard);
    qDashBoardLastKilosService.Name := 'qDashBoardLastKilosService';
    qDashBoardLastKilosService.FieldName := 'LastKilosService';
    qDashBoardLastKilosService.DisplayFormat := '#,##0';
    qDashBoardKilosNextService.SetParentComponent(qDashBoard);
    qDashBoardKilosNextService.Name := 'qDashBoardKilosNextService';
    qDashBoardKilosNextService.FieldName := 'KilosNextService';
    qDashBoardKilosNextService.DisplayFormat := '#,##0';
    qDashBoardDieselOrder.SetParentComponent(qDashBoard);
    qDashBoardDieselOrder.Name := 'qDashBoardDieselOrder';
    qDashBoardDieselOrder.FieldName := 'DieselOrder';
    qDashBoardWarnings.SetParentComponent(qDashBoard);
    qDashBoardWarnings.Name := 'qDashBoardWarnings';
    qDashBoardWarnings.FieldName := 'Warnings';
    qDashBoardLastLoadStart.SetParentComponent(qDashBoard);
    qDashBoardLastLoadStart.Name := 'qDashBoardLastLoadStart';
    qDashBoardLastLoadStart.FieldName := 'LastLoadStart';
    qDashBoardLastLoadPlan.SetParentComponent(qDashBoard);
    qDashBoardLastLoadPlan.Name := 'qDashBoardLastLoadPlan';
    qDashBoardLastLoadPlan.FieldName := 'LastLoadPlan';
    qDashBoardLastDieselOrder.SetParentComponent(qDashBoard);
    qDashBoardLastDieselOrder.Name := 'qDashBoardLastDieselOrder';
    qDashBoardLastDieselOrder.FieldName := 'LastDieselOrder';
    qDashBoardLoadEndTime.SetParentComponent(qDashBoard);
    qDashBoardLoadEndTime.Name := 'qDashBoardLoadEndTime';
    qDashBoardLoadEndTime.FieldName := 'LoadEndTime';
    qDashBoardCurrentTime.SetParentComponent(qDashBoard);
    qDashBoardCurrentTime.Name := 'qDashBoardCurrentTime';
    qDashBoardCurrentTime.FieldName := 'CurrentTime';
    qDashBoardTotalHours.SetParentComponent(qDashBoard);
    qDashBoardTotalHours.Name := 'qDashBoardTotalHours';
    qDashBoardTotalHours.FieldName := 'TotalHours';
    qDashBoardTimeLeft.SetParentComponent(qDashBoard);
    qDashBoardTimeLeft.Name := 'qDashBoardTimeLeft';
    qDashBoardTimeLeft.FieldName := 'TimeLeft';
    qDashBoardFirstwarning.SetParentComponent(qDashBoard);
    qDashBoardFirstwarning.Name := 'qDashBoardFirstwarning';
    qDashBoardFirstwarning.FieldName := 'Firstwarning';
    qDashBoardSecondwarning.SetParentComponent(qDashBoard);
    qDashBoardSecondwarning.Name := 'qDashBoardSecondwarning';
    qDashBoardSecondwarning.FieldName := 'Secondwarning';
    qDashBoardGroupNo.SetParentComponent(qDashBoard);
    qDashBoardGroupNo.Name := 'qDashBoardGroupNo';
    qDashBoardGroupNo.FieldName := 'GroupNo';
    qDashBoardGroupName.SetParentComponent(qDashBoard);
    qDashBoardGroupName.Name := 'qDashBoardGroupName';
    qDashBoardGroupName.FieldName := 'GroupName';
    qDashBoardRevenu.SetParentComponent(qDashBoard);
    qDashBoardRevenu.Name := 'qDashBoardRevenu';
    qDashBoardRevenu.FieldName := 'Revenu';
    qDashBoardSurplus.SetParentComponent(qDashBoard);
    qDashBoardSurplus.Name := 'qDashBoardSurplus';
    qDashBoardSurplus.FieldName := 'Surplus';
    qDashBoardDayAverage.SetParentComponent(qDashBoard);
    qDashBoardDayAverage.Name := 'qDashBoardDayAverage';
    qDashBoardDayAverage.FieldName := 'DayAverage';
    qDashBoardDayGood.SetParentComponent(qDashBoard);
    qDashBoardDayGood.Name := 'qDashBoardDayGood';
    qDashBoardDayGood.FieldName := 'DayGood';
    qDashBoardDayFirst.SetParentComponent(qDashBoard);
    qDashBoardDayFirst.Name := 'qDashBoardDayFirst';
    qDashBoardDayFirst.FieldName := 'DayFirst';
    qDashBoardDaySecond.SetParentComponent(qDashBoard);
    qDashBoardDaySecond.Name := 'qDashBoardDaySecond';
    qDashBoardDaySecond.FieldName := 'DaySecond';
    qDashBoardRevToDate.SetParentComponent(qDashBoard);
    qDashBoardRevToDate.Name := 'qDashBoardRevToDate';
    qDashBoardRevToDate.FieldName := 'RevToDate';
    qDashBoardSurplusToDate.SetParentComponent(qDashBoard);
    qDashBoardSurplusToDate.Name := 'qDashBoardSurplusToDate';
    qDashBoardSurplusToDate.FieldName := 'SurplusToDate';
    qDashBoardFuelConsumption.SetParentComponent(qDashBoard);
    qDashBoardFuelConsumption.Name := 'qDashBoardFuelConsumption';
    qDashBoardFuelConsumption.FieldName := 'FuelConsumption';
    qDashBoardLoadCount.SetParentComponent(qDashBoard);
    qDashBoardLoadCount.Name := 'qDashBoardLoadCount';
    qDashBoardLoadCount.FieldName := 'LoadCount';
    qDashBoardSurplusPerc.SetParentComponent(qDashBoard);
    qDashBoardSurplusPerc.Name := 'qDashBoardSurplusPerc';
    qDashBoardSurplusPerc.FieldName := 'SurplusPerc';
    dsDashBoard.SetParentComponent(Self);
    dsDashBoard.Name := 'dsDashBoard';
    dsDashBoard.AutoEdit := False;
    dsDashBoard.DataSet := qDashBoard;
    dsDashBoard.Left := 768;
    dsDashBoard.Top := 209;
    wcDashBoard.SetParentComponent(Self);
    wcDashBoard.Name := 'wcDashBoard';
    wcDashBoard.Connection := dmData.dbConnect;
    wcDashBoard.Left := 928;
    wcDashBoard.Top := 193;
    qTotals.SetParentComponent(Self);
    qTotals.Name := 'qTotals';
    qTotals.AfterOpen := qTotalsAfterOpen;
    qTotals.Connection := dmData.dbConnect;
    qTotals.Left := 600;
    qTotals.Top := 433;
    qTotalsCount.SetParentComponent(qTotals);
    qTotalsCount.Name := 'qTotalsCount';
    qTotalsCount.FieldName := 'Count';
    qTotalsRevenue.SetParentComponent(qTotals);
    qTotalsRevenue.Name := 'qTotalsRevenue';
    qTotalsRevenue.FieldName := 'Revenue';
    qTotalsSurplus.SetParentComponent(qTotals);
    qTotalsSurplus.Name := 'qTotalsSurplus';
    qTotalsSurplus.FieldName := 'Surplus';
    qTotalsDayAverage.SetParentComponent(qTotals);
    qTotalsDayAverage.Name := 'qTotalsDayAverage';
    qTotalsDayAverage.FieldName := 'DayAverage';
    qTotalsFuel.SetParentComponent(qTotals);
    qTotalsFuel.Name := 'qTotalsFuel';
    qTotalsFuel.FieldName := 'Fuel';
    dsTotals.SetParentComponent(Self);
    dsTotals.Name := 'dsTotals';
    dsTotals.AutoEdit := False;
    dsTotals.DataSet := qTotals;
    dsTotals.Left := 680;
    dsTotals.Top := 433;
    wcTotals.SetParentComponent(Self);
    wcTotals.Name := 'wcTotals';
    wcTotals.Connection := dmData.dbConnect;
    wcTotals.Left := 840;
    wcTotals.Top := 417;
  finally
    WebLabel1.AfterLoadDFMValues;
    gdaDashBoard.AfterLoadDFMValues;
    TMSFNCPageControl1.AfterLoadDFMValues;
    TMSFNCPageControl1Page2.AfterLoadDFMValues;
    TMSFNCPageControl1Page1.AfterLoadDFMValues;
    TMSFNCPageControl1Page0.AfterLoadDFMValues;
    pPlanner.AfterLoadDFMValues;
    pdaPlanner.AfterLoadDFMValues;
    wpLoadsButtons.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    wpLoadsAdd.AfterLoadDFMValues;
    WebWaitMessage1.AfterLoadDFMValues;
    TMSFNCPageControl1Page3.AfterLoadDFMValues;
    gDashBoard.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    sbBottom.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    weCount.AfterLoadDFMValues;
    weTotalRev.AfterLoadDFMValues;
    weTotalSurplus.AfterLoadDFMValues;
    weAvgDay.AfterLoadDFMValues;
    weAvgFuel.AfterLoadDFMValues;
    sbDashBoard.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    lCompany.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    lGroup.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    lRegNo.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    lController.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    dtPicker.AfterLoadDFMValues;
    btnSearch.AfterLoadDFMValues;
    wcPlanning.AfterLoadDFMValues;
    qPlanning.AfterLoadDFMValues;
    qPlanningNo.AfterLoadDFMValues;
    qPlanningRegSource.AfterLoadDFMValues;
    qPlanningRegNo.AfterLoadDFMValues;
    qPlanningContractNo.AfterLoadDFMValues;
    qPlanningContractName.AfterLoadDFMValues;
    qPlanningSubCode.AfterLoadDFMValues;
    qPlanningSubName.AfterLoadDFMValues;
    qPlanningCanceled.AfterLoadDFMValues;
    qPlanningLoaded.AfterLoadDFMValues;
    qPlanningOffLoaded.AfterLoadDFMValues;
    qPlanningLoadconno.AfterLoadDFMValues;
    qPlanningCInvoiceNo.AfterLoadDFMValues;
    qPlanningCInvoiced.AfterLoadDFMValues;
    qPlanningSInvoiceNo.AfterLoadDFMValues;
    qPlanningSInvoiced.AfterLoadDFMValues;
    qPlanningLoadStandTime.AfterLoadDFMValues;
    qPlanningOffLoadStandTime.AfterLoadDFMValues;
    qPlanningTrafelTime.AfterLoadDFMValues;
    qPlanningTimeLeft.AfterLoadDFMValues;
    qPlanningLoadingDate.AfterLoadDFMValues;
    qPlanningOffLoadingDate.AfterLoadDFMValues;
    qPlanningSystemType.AfterLoadDFMValues;
    dsPlanning.AfterLoadDFMValues;
    qResources.AfterLoadDFMValues;
    qResourcesNo.AfterLoadDFMValues;
    qResourcesRegNo.AfterLoadDFMValues;
    dsResources.AfterLoadDFMValues;
    wcResources.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
    qDashBoard.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    qDashBoardSubCode.AfterLoadDFMValues;
    qDashBoardSubName.AfterLoadDFMValues;
    qDashBoardLoadsNotStarted.AfterLoadDFMValues;
    qDashBoardLoadsStarted.AfterLoadDFMValues;
    qDashBoardKilos.AfterLoadDFMValues;
    qDashBoardLastKilosService.AfterLoadDFMValues;
    qDashBoardKilosNextService.AfterLoadDFMValues;
    qDashBoardDieselOrder.AfterLoadDFMValues;
    qDashBoardWarnings.AfterLoadDFMValues;
    qDashBoardLastLoadStart.AfterLoadDFMValues;
    qDashBoardLastLoadPlan.AfterLoadDFMValues;
    qDashBoardLastDieselOrder.AfterLoadDFMValues;
    qDashBoardLoadEndTime.AfterLoadDFMValues;
    qDashBoardCurrentTime.AfterLoadDFMValues;
    qDashBoardTotalHours.AfterLoadDFMValues;
    qDashBoardTimeLeft.AfterLoadDFMValues;
    qDashBoardFirstwarning.AfterLoadDFMValues;
    qDashBoardSecondwarning.AfterLoadDFMValues;
    qDashBoardGroupNo.AfterLoadDFMValues;
    qDashBoardGroupName.AfterLoadDFMValues;
    qDashBoardRevenu.AfterLoadDFMValues;
    qDashBoardSurplus.AfterLoadDFMValues;
    qDashBoardDayAverage.AfterLoadDFMValues;
    qDashBoardDayGood.AfterLoadDFMValues;
    qDashBoardDayFirst.AfterLoadDFMValues;
    qDashBoardDaySecond.AfterLoadDFMValues;
    qDashBoardRevToDate.AfterLoadDFMValues;
    qDashBoardSurplusToDate.AfterLoadDFMValues;
    qDashBoardFuelConsumption.AfterLoadDFMValues;
    qDashBoardLoadCount.AfterLoadDFMValues;
    qDashBoardSurplusPerc.AfterLoadDFMValues;
    dsDashBoard.AfterLoadDFMValues;
    wcDashBoard.AfterLoadDFMValues;
    qTotals.AfterLoadDFMValues;
    qTotalsCount.AfterLoadDFMValues;
    qTotalsRevenue.AfterLoadDFMValues;
    qTotalsSurplus.AfterLoadDFMValues;
    qTotalsDayAverage.AfterLoadDFMValues;
    qTotalsFuel.AfterLoadDFMValues;
    dsTotals.AfterLoadDFMValues;
    wcTotals.AfterLoadDFMValues;
  end;
end;

end.
